var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySevas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 169.807,
    viewBox: "0 0 260 169.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_",
    "data-name": "Illustration ",
    transform: "translate(-52.41 -36.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-12",
    transform: "translate(52.41 36.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510078",
    "data-name": "Path 510078",
    d: "M77.979,319.062c-3.091.056-7.592.177-10.642.177H67.16v-.177l-.02-4.5v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.088,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.109-4.5l.109.108c-3.078.056-7.519.08-10.642.088l.2-.2-.024,4.5-.177-.181C70.347,318.881,74.929,319,77.979,319.062Z",
    transform: "translate(-61.22 -202.628)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510079",
    "data-name": "Path 510079",
    d: "M63.233,333.172c-3.091.056-7.592.177-10.642.177H52.41V328.47h.2c3.183,0,7.612.028,10.751.092,0,1.362-.084,3.215-.109,4.606Zm0,0c-.04-1.318-.084-3.215-.109-4.5l.109.109c-3.078.056-7.519.08-10.642.088l.2-.2-.024,4.5-.177-.181C55.6,332.991,60.183,333.108,63.233,333.172Z",
    transform: "translate(-52.41 -211.068)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510080",
    "data-name": "Path 510080",
    d: "M436.771,174.842c-3.087.056-7.592.177-10.642.177h-.165v-.177l-.024-4.5v-.2h.2c3.187,0,7.616.028,10.755.092,0,1.362-.088,3.215-.113,4.606Zm0,0c-.036-1.318-.08-3.215-.109-4.5l.109.109c-3.074.056-7.519.08-10.642.092l.2-.2-.02,4.5-.181-.181C429.139,174.661,433.725,174.778,436.771,174.842Z",
    transform: "translate(-275.821 -116.369)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510081",
    "data-name": "Path 510081",
    d: "M421.983,189c-3.091.056-7.592.177-10.642.177h-.177V189l-.024-4.5v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.088,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.108-4.5l.108.109c-3.074.056-7.519.08-10.642.092l.2-.2-.02,4.5-.181-.181C414.351,188.821,418.933,188.938,421.983,189Z",
    transform: "translate(-266.969 -124.839)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510082",
    "data-name": "Path 510082",
    d: "M407.279,174.842c-3.091.056-7.592.177-10.642.177h-.177v-.177l-.02-4.5v-.2h.2c3.183,0,7.612.028,10.751.092,0,1.362-.084,3.215-.109,4.606Zm0,0c-.04-1.318-.08-3.215-.109-4.5l.109.109c-3.079.056-7.519.08-10.642.092l.2-.2-.024,4.5-.177-.181C399.647,174.661,404.229,174.778,407.279,174.842Z",
    transform: "translate(-258.177 -116.369)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510083",
    "data-name": "Path 510083",
    d: "M681,333.184c-3.09.056-7.592.177-10.642.177h-.177v-.177l-.024-4.489v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.088,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.108-4.5l.108.108c-3.074.056-7.519.08-10.642.088l.2-.2v4.5l-.181-.181c3.01,0,7.592.117,10.642.181Z",
    transform: "translate(-421.891 -211.08)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510084",
    "data-name": "Path 510084",
    d: "M666.239,59.486c-3.091.056-7.592.177-10.642.177h-.177v-.181l-.02-4.5v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.089,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.109-4.5l.109.109c-3.078.056-7.519.084-10.642.092l.2-.2v4.5l-.181-.181c3.01,0,7.592.117,10.642.181Z",
    transform: "translate(-413.063 -47.372)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510085",
    "data-name": "Path 510085",
    d: "M681,73.6c-3.091.056-7.592.177-10.642.177h-.177V73.6l-.024-4.5v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.089,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.109-4.5l.109.109c-3.074.056-7.519.084-10.642.092l.2-.2v4.5l-.181-.181c3.01,0,7.592.117,10.642.181Z",
    transform: "translate(-421.891 -55.817)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510086",
    "data-name": "Path 510086",
    d: "M77.973,59.492c-3.091.056-7.592.177-10.642.177h-.177v-.181l-.024-4.493v-.2h.2c3.187,0,7.612.028,10.755.092,0,1.362-.088,3.215-.113,4.606Zm0,0c-.04-1.318-.08-3.215-.109-4.5l.109.109c-3.078.056-7.519.084-10.642.092l.2-.2-.024,4.5-.177-.2c3.01,0,7.592.117,10.642.181Z",
    transform: "translate(-61.214 -47.378)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510087",
    "data-name": "Path 510087",
    d: "M61.893,377.571h75.114l1.559-30.821H60.33Z",
    transform: "translate(-57.147 -222.001)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510088",
    "data-name": "Path 510088",
    d: "M194.651,365.928h-31.4l-.587-10.7h32.69Zm-31.05-.378h30.689l.659-9.943h-31.89Z",
    transform: "translate(-118.351 -227.073)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510089",
    "data-name": "Path 510089",
    d: "M196.064,398.125h-29.6l-.478-9.645h30.676Zm-29.234-.378h28.876l.555-8.9H166.4Z",
    transform: "translate(-120.343 -246.96)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510090",
    "data-name": "Path 510090",
    d: "M202.366,367.59H197.09l-.33-2.58h5.94Zm-4.943-.378h4.61l.237-1.825h-5.08Z",
    transform: "translate(-138.747 -232.923)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510091",
    "data-name": "Path 510091",
    d: "M202.366,399.84H197.09l-.33-2.58h5.94Zm-4.943-.382h4.61l.237-1.821h-5.08Z",
    transform: "translate(-138.747 -252.212)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510092",
    "data-name": "Path 510092",
    d: "M102.741,365.928h-31.4l-.587-10.7h32.678ZM71.7,365.551h30.688l.635-9.943H71.148Z",
    transform: "translate(-63.379 -227.073)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510093",
    "data-name": "Path 510093",
    d: "M104.154,398.125h-29.6l-.478-9.645h30.676Zm-29.234-.378h28.868l.559-8.9H74.478Z",
    transform: "translate(-65.371 -246.96)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510094",
    "data-name": "Path 510094",
    d: "M110.46,367.59h-5.277l-.334-2.58h5.94Zm-4.947-.378h4.622l.233-1.825H105.28Z",
    transform: "translate(-83.775 -232.923)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510095",
    "data-name": "Path 510095",
    d: "M110.46,399.84h-5.277l-.334-2.58h5.94Zm-4.947-.382h4.622l.233-1.821H105.28Z",
    transform: "translate(-83.775 -252.212)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510096",
    "data-name": "Path 510096",
    d: "M76.105,423.44l-.47,3.356-.952,6.748H72.83v-10.1Z",
    transform: "translate(-64.623 -267.87)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510097",
    "data-name": "Path 510097",
    d: "M76.105,423.44l-.47,3.356H72.83V423.44Z",
    transform: "translate(-64.623 -267.87)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510098",
    "data-name": "Path 510098",
    d: "M234.35,423.44l.474,3.356.948,6.748h1.853v-10.1Z",
    transform: "translate(-161.23 -267.87)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510099",
    "data-name": "Path 510099",
    d: "M234.35,423.44l.474,3.356h2.8V423.44Z",
    transform: "translate(-161.23 -267.87)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204005",
    "data-name": "Rectangle 204005",
    width: 22.747,
    height: 27.59,
    transform: "translate(236.574 19.726)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204006",
    "data-name": "Rectangle 204006",
    width: 17.547,
    height: 22.554,
    transform: "translate(239.17 22.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204007",
    "data-name": "Rectangle 204007",
    width: 0.683,
    height: 22.554,
    transform: "translate(239.17 22.246)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204008",
    "data-name": "Rectangle 204008",
    width: 0.683,
    height: 27.59,
    transform: "translate(259.317 19.726)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204009",
    "data-name": "Rectangle 204009",
    width: 4.139,
    height: 12.326,
    transform: "translate(245.05 25.353)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510100",
    "data-name": "Path 510100",
    d: "M668.6,126.28H657.16v-6.43H668.6Zm-11.036-.4H668.2v-5.627H657.562Z",
    transform: "translate(-414.116 -86.291)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204010",
    "data-name": "Rectangle 204010",
    width: 22.747,
    height: 27.59,
    transform: "translate(225.2 57.138)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204011",
    "data-name": "Rectangle 204011",
    width: 17.547,
    height: 22.554,
    transform: "translate(227.797 59.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204012",
    "data-name": "Rectangle 204012",
    width: 0.683,
    height: 22.554,
    transform: "translate(227.797 59.654)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204013",
    "data-name": "Rectangle 204013",
    width: 0.683,
    height: 27.59,
    transform: "translate(247.943 57.138)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204014",
    "data-name": "Rectangle 204014",
    width: 3.545,
    height: 8.962,
    transform: "translate(234.874 65.486)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510101",
    "data-name": "Path 510101",
    d: "M640.663,218.919H630.74V212.34h9.923Zm-9.521-.4h9.119v-5.775h-9.119Z",
    transform: "translate(-398.314 -141.61)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16801",
    "data-name": "Ellipse 16801",
    cx: 17.691,
    cy: 17.691,
    r: 17.691,
    transform: "translate(2.973 33.694) rotate(-72.23)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16802",
    "data-name": "Ellipse 16802",
    cx: 16.879,
    cy: 16.879,
    r: 16.879,
    transform: "translate(3.744 14.085) rotate(-24.01)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16803",
    "data-name": "Ellipse 16803",
    cx: 15.885,
    cy: 15.885,
    r: 15.885,
    transform: "translate(7.88 9.878) rotate(-9.744)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510102",
    "data-name": "Path 510102",
    d: "M111.023,68.486c-7.2,4.361-19.034,11.522-25.653,15.445a15.879,15.879,0,0,1-4.32-5.811L102.929,57.84A15.827,15.827,0,0,1,111.023,68.486Z",
    transform: "translate(-69.54 -49.202)",
    fill: "#ebebeb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510103",
    "data-name": "Path 510103",
    d: "M121.882,94.05a15.7,15.7,0,0,1-1.045,5.14l-19.725,9.328a15.948,15.948,0,0,1-2.492-1.073C104.58,104,115.467,97.739,121.882,94.05Z",
    transform: "translate(-80.049 -70.859)",
    fill: "#ebebeb",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204015",
    "data-name": "Rectangle 204015",
    width: 0.305,
    height: 2.395,
    transform: "translate(25.878 7.971)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204016",
    "data-name": "Rectangle 204016",
    width: 0.305,
    height: 2.395,
    transform: "translate(18.564 10.009) rotate(-30)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204017",
    "data-name": "Rectangle 204017",
    width: 0.305,
    height: 2.395,
    transform: "translate(13.248 15.438) rotate(-60)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204018",
    "data-name": "Rectangle 204018",
    width: 2.395,
    height: 0.305,
    transform: "translate(11.361 22.487)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204019",
    "data-name": "Rectangle 204019",
    width: 2.395,
    height: 0.305,
    transform: "translate(13.248 29.84) rotate(-30)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204020",
    "data-name": "Rectangle 204020",
    width: 2.395,
    height: 0.305,
    transform: "translate(18.563 35.263) rotate(-60.04)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204021",
    "data-name": "Rectangle 204021",
    width: 0.305,
    height: 2.395,
    transform: "translate(25.878 34.91)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204022",
    "data-name": "Rectangle 204022",
    width: 0.305,
    height: 2.395,
    transform: "translate(32.03 33.342) rotate(-30)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204023",
    "data-name": "Rectangle 204023",
    width: 0.305,
    height: 2.395,
    transform: "translate(36.576 28.902) rotate(-60)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204024",
    "data-name": "Rectangle 204024",
    width: 2.395,
    height: 0.305,
    transform: "translate(38.296 22.487)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204025",
    "data-name": "Rectangle 204025",
    width: 2.395,
    height: 0.305,
    transform: "translate(36.581 16.374) rotate(-30)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204026",
    "data-name": "Rectangle 204026",
    width: 2.395,
    height: 0.305,
    transform: "translate(32.033 11.934) rotate(-60.03)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510104",
    "data-name": "Path 510104",
    d: "M116.291,58.878l.518,14.645-1.5-.016.571-14.637Z",
    transform: "translate(-90.031 -49.818)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510105",
    "data-name": "Path 510105",
    d: "M124.72,79.438l-9.854,6.29-.715-1.318,10.377-5.329Z",
    transform: "translate(-89.337 -61.906)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510106",
    "data-name": "Path 510106",
    d: "M116.919,91.914a.51.51,0,1,1-.148-.363A.514.514,0,0,1,116.919,91.914Z",
    transform: "translate(-90.378 -69.274)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-12",
    transform: "translate(77.918 53.135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204027",
    "data-name": "Rectangle 204027",
    width: 188.395,
    height: 141.824,
    transform: "translate(9.943 7.061)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204028",
    "data-name": "Rectangle 204028",
    width: 9.939,
    height: 141.824,
    transform: "translate(9.943 148.885) rotate(180)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204029",
    "data-name": "Rectangle 204029",
    width: 188.395,
    height: 15.3,
    transform: "translate(9.943 7.061)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204030",
    "data-name": "Rectangle 204030",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 37.589)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204031",
    "data-name": "Rectangle 204031",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 37.589)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204032",
    "data-name": "Rectangle 204032",
    width: 18.664,
    height: 18.664,
    transform: "translate(51.611 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204033",
    "data-name": "Rectangle 204033",
    width: 18.664,
    height: 18.664,
    transform: "translate(73.217 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204034",
    "data-name": "Rectangle 204034",
    width: 18.664,
    height: 18.664,
    transform: "translate(94.806 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204035",
    "data-name": "Rectangle 204035",
    width: 18.664,
    height: 18.664,
    transform: "translate(116.4 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204036",
    "data-name": "Rectangle 204036",
    width: 18.664,
    height: 18.664,
    transform: "translate(137.99 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204037",
    "data-name": "Rectangle 204037",
    width: 18.664,
    height: 18.664,
    transform: "translate(159.583 37.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204038",
    "data-name": "Rectangle 204038",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 58.696)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204039",
    "data-name": "Rectangle 204039",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 58.696)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204040",
    "data-name": "Rectangle 204040",
    width: 18.664,
    height: 18.664,
    transform: "translate(51.623 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204041",
    "data-name": "Rectangle 204041",
    width: 18.664,
    height: 18.664,
    transform: "translate(73.213 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204042",
    "data-name": "Rectangle 204042",
    width: 18.664,
    height: 18.664,
    transform: "translate(94.806 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204043",
    "data-name": "Rectangle 204043",
    width: 18.664,
    height: 18.664,
    transform: "translate(116.4 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204044",
    "data-name": "Rectangle 204044",
    width: 18.664,
    height: 18.664,
    transform: "translate(137.994 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204045",
    "data-name": "Rectangle 204045",
    width: 18.664,
    height: 18.664,
    transform: "translate(159.583 58.696)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204046",
    "data-name": "Rectangle 204046",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 79.804)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204047",
    "data-name": "Rectangle 204047",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 79.804)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204048",
    "data-name": "Rectangle 204048",
    width: 18.664,
    height: 18.664,
    transform: "translate(51.623 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204049",
    "data-name": "Rectangle 204049",
    width: 18.664,
    height: 18.664,
    transform: "translate(73.217 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204050",
    "data-name": "Rectangle 204050",
    width: 18.664,
    height: 18.664,
    transform: "translate(94.806 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204051",
    "data-name": "Rectangle 204051",
    width: 18.664,
    height: 18.664,
    transform: "translate(116.4 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204052",
    "data-name": "Rectangle 204052",
    width: 18.664,
    height: 18.664,
    transform: "translate(137.99 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204053",
    "data-name": "Rectangle 204053",
    width: 18.664,
    height: 18.664,
    transform: "translate(159.583 79.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204054",
    "data-name": "Rectangle 204054",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 100.911)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204055",
    "data-name": "Rectangle 204055",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 100.911)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204056",
    "data-name": "Rectangle 204056",
    width: 18.664,
    height: 18.664,
    transform: "translate(51.623 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204057",
    "data-name": "Rectangle 204057",
    width: 18.664,
    height: 18.664,
    transform: "translate(73.213 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204058",
    "data-name": "Rectangle 204058",
    width: 18.664,
    height: 18.664,
    transform: "translate(94.806 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204059",
    "data-name": "Rectangle 204059",
    width: 18.664,
    height: 18.664,
    transform: "translate(116.4 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204060",
    "data-name": "Rectangle 204060",
    width: 18.664,
    height: 18.664,
    transform: "translate(137.994 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204061",
    "data-name": "Rectangle 204061",
    width: 18.664,
    height: 18.664,
    transform: "translate(159.583 100.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204062",
    "data-name": "Rectangle 204062",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 122.019)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204063",
    "data-name": "Rectangle 204063",
    width: 18.664,
    height: 18.664,
    transform: "translate(30.029 122.019)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204064",
    "data-name": "Rectangle 204064",
    width: 18.664,
    height: 18.664,
    transform: "translate(51.623 122.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204065",
    "data-name": "Rectangle 204065",
    width: 18.664,
    height: 18.664,
    transform: "translate(73.213 122.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204066",
    "data-name": "Rectangle 204066",
    width: 18.664,
    height: 18.664,
    transform: "translate(94.806 122.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204067",
    "data-name": "Rectangle 204067",
    width: 18.664,
    height: 18.664,
    transform: "translate(116.4 122.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204068",
    "data-name": "Rectangle 204068",
    width: 18.664,
    height: 18.664,
    transform: "translate(137.99 122.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204069",
    "data-name": "Rectangle 204069",
    width: 18.664,
    height: 18.664,
    transform: "translate(159.583 122.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510107",
    "data-name": "Path 510107",
    d: "M205.547,159.273a.832.832,0,0,0-.317-.213,1.106,1.106,0,0,0-.446-.084.84.84,0,0,0-.539.141.466.466,0,0,0-.169.378.363.363,0,0,0,.185.35.989.989,0,0,0,.241.1l.346.088a2.974,2.974,0,0,1,.4.1,1.137,1.137,0,0,1,.305.149.574.574,0,0,1,.193.213.671.671,0,0,1,.064.313.747.747,0,0,1-.072.338.683.683,0,0,1-.209.233.881.881,0,0,1-.317.141,1.633,1.633,0,0,1-.4.044,1.664,1.664,0,0,1-1.121-.4l.137-.225a1.112,1.112,0,0,0,.177.149,1.342,1.342,0,0,0,.506.2,1.523,1.523,0,0,0,.309.032.953.953,0,0,0,.518-.121.4.4,0,0,0,.189-.366.454.454,0,0,0-.052-.217.4.4,0,0,0-.161-.153,1.1,1.1,0,0,0-.265-.113c-.1-.032-.225-.064-.366-.1s-.273-.068-.4-.1a1.114,1.114,0,0,1-.277-.137.587.587,0,0,1-.173-.2.667.667,0,0,1-.056-.285.8.8,0,0,1,.072-.346.627.627,0,0,1,.209-.249.876.876,0,0,1,.313-.153,1.491,1.491,0,0,1,.9.028,1.282,1.282,0,0,1,.4.241Z",
    transform: "translate(-168.4 -126.333)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510108",
    "data-name": "Path 510108",
    d: "M211.254,161.348a.9.9,0,0,0,.438-.1.8.8,0,0,0,.277-.265,1.036,1.036,0,0,0,.149-.37,2.5,2.5,0,0,0,.04-.422V158.78h.273v1.411a2.3,2.3,0,0,1-.06.535,1.249,1.249,0,0,1-.2.45.992.992,0,0,1-.362.305,1.371,1.371,0,0,1-1.105,0,.981.981,0,0,1-.362-.313,1.23,1.23,0,0,1-.2-.45,2.232,2.232,0,0,1-.06-.518v-1.411h.269V160.2a2.2,2.2,0,0,0,.044.43,1.117,1.117,0,0,0,.149.37.775.775,0,0,0,.277.257A.848.848,0,0,0,211.254,161.348Z",
    transform: "translate(-172.222 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510109",
    "data-name": "Path 510109",
    d: "M217.857,159.294v2.279h-.277V158.78h.213l1.849,2.327v-2.323h.277v2.789h-.241Z",
    transform: "translate(-176.708 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510110",
    "data-name": "Path 510110",
    d: "M259.146,161.555v-2.3l-1.021,1.772h-.161l-1.021-1.772v2.291h-.273V158.75h.281l1.093,1.913,1.1-1.913h.277v2.793Z",
    transform: "translate(-200.088 -126.345)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510111",
    "data-name": "Path 510111",
    d: "M266.122,161.563a1.173,1.173,0,0,1-.535-.121,1.238,1.238,0,0,1-.4-.317,1.43,1.43,0,0,1-.269-.454,1.467,1.467,0,0,1-.1-.522,1.5,1.5,0,0,1,.1-.535,1.531,1.531,0,0,1,.277-.454,1.394,1.394,0,0,1,.4-.313,1.206,1.206,0,0,1,.518-.117,1.177,1.177,0,0,1,.535.125,1.378,1.378,0,0,1,.4.326,1.552,1.552,0,0,1,.265.454,1.447,1.447,0,0,1,.1.518,1.471,1.471,0,0,1-.378.985,1.39,1.39,0,0,1-.4.313A1.206,1.206,0,0,1,266.122,161.563Zm-1.037-1.415a1.24,1.24,0,0,0,.076.438,1.144,1.144,0,0,0,.213.374.985.985,0,0,0,.326.261.908.908,0,0,0,.422.1.892.892,0,0,0,.426-.1,1.113,1.113,0,0,0,.33-.265,1.294,1.294,0,0,0,.277-.8,1.241,1.241,0,0,0-.076-.438,1.309,1.309,0,0,0-.213-.374,1.029,1.029,0,0,0-.33-.257.953.953,0,0,0-.844,0,1.05,1.05,0,0,0-.326.265,1.205,1.205,0,0,0-.209.374A1.3,1.3,0,0,0,265.085,160.149Z",
    transform: "translate(-204.962 -126.333)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510112",
    "data-name": "Path 510112",
    d: "M272.887,159.294v2.279h-.277V158.78h.213l1.849,2.327v-2.323h.277v2.789h-.241Z",
    transform: "translate(-209.621 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510113",
    "data-name": "Path 510113",
    d: "M314.047,159.025h-1v2.548h-.277v-2.548h-.993v-.245h2.267Z",
    transform: "translate(-233.049 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510114",
    "data-name": "Path 510114",
    d: "M319.529,161.348a.92.92,0,0,0,.442-.1.8.8,0,0,0,.277-.265,1.111,1.111,0,0,0,.145-.37,2.152,2.152,0,0,0,.044-.422V158.78h.273v1.411a2.094,2.094,0,0,1-.064.535,1.241,1.241,0,0,1-.2.45.977.977,0,0,1-.366.305,1.182,1.182,0,0,1-.547.113,1.153,1.153,0,0,1-.555-.121,1,1,0,0,1-.366-.313,1.3,1.3,0,0,1-.2-.45,2.228,2.228,0,0,1-.056-.518V158.78h.257v1.411a2.2,2.2,0,0,0,.044.43,1.037,1.037,0,0,0,.149.37.776.776,0,0,0,.277.257A.8.8,0,0,0,319.529,161.348Z",
    transform: "translate(-236.985 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510115",
    "data-name": "Path 510115",
    d: "M327.727,161.332v.241H325.85V158.78h1.841v.245h-1.567v1.009h1.366v.229h-1.366v1.069Z",
    transform: "translate(-241.465 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510116",
    "data-name": "Path 510116",
    d: "M364.882,158.818h.261l.4.993.4-.993h.261l-.486,1.206.534,1.262,1.013-2.476h.3l-1.182,2.793h-.249l-.587-1.378-.591,1.378h-.241l-1.178-2.793h.293l1.017,2.476.531-1.262Z",
    transform: "translate(-264.007 -126.381)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510117",
    "data-name": "Path 510117",
    d: "M376.387,161.332v.241H374.51V158.78h1.841v.245h-1.563v1.009h1.366v.229h-1.366v1.069Z",
    transform: "translate(-270.569 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510118",
    "data-name": "Path 510118",
    d: "M380.48,161.572v-2.793h.944a1.4,1.4,0,0,1,.587.113,1.206,1.206,0,0,1,.4.3,1.289,1.289,0,0,1,.249.442,1.7,1.7,0,0,1,.084.543,1.608,1.608,0,0,1-.092.575,1.258,1.258,0,0,1-.269.442,1.178,1.178,0,0,1-.422.281,1.435,1.435,0,0,1-.555.1Zm2.009-1.4a1.411,1.411,0,0,0-.072-.462,1.121,1.121,0,0,0-.2-.366.953.953,0,0,0-.334-.237,1.146,1.146,0,0,0-.454-.084h-.671v2.307h.671a1.169,1.169,0,0,0,.462-.088.92.92,0,0,0,.33-.245,1.053,1.053,0,0,0,.2-.366A1.519,1.519,0,0,0,382.489,160.174Z",
    transform: "translate(-274.139 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510119",
    "data-name": "Path 510119",
    d: "M420.867,159.025h-1v2.548h-.277v-2.548H418.6v-.245h2.267Z",
    transform: "translate(-296.939 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510120",
    "data-name": "Path 510120",
    d: "M427.5,158.78v2.793h-.273v-1.306h-1.64v1.306h-.277V158.78h.277v1.246h1.656V158.78Z",
    transform: "translate(-300.952 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510121",
    "data-name": "Path 510121",
    d: "M433.574,161.348a.892.892,0,0,0,.438-.1.8.8,0,0,0,.281-.265,1.111,1.111,0,0,0,.145-.37,2.145,2.145,0,0,0,.04-.422V158.78h.277v1.411a2.09,2.09,0,0,1-.064.535,1.241,1.241,0,0,1-.2.45,1.009,1.009,0,0,1-.366.305,1.181,1.181,0,0,1-.547.113,1.153,1.153,0,0,1-.555-.121,1,1,0,0,1-.366-.313,1.3,1.3,0,0,1-.2-.45,2.23,2.23,0,0,1-.06-.518V158.78h.273v1.411a1.925,1.925,0,0,0,.044.43,1.11,1.11,0,0,0,.145.37.8.8,0,0,0,.711.358Z",
    transform: "translate(-305.193 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510122",
    "data-name": "Path 510122",
    d: "M476,161.573V158.78h1.833v.245h-1.555v1.049h1.33v.225h-1.314v1.294Z",
    transform: "translate(-331.271 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510123",
    "data-name": "Path 510123",
    d: "M481.8,161.573V158.78h1.182a.751.751,0,0,1,.33.076.924.924,0,0,1,.261.2.9.9,0,0,1,.233.6,1.034,1.034,0,0,1-.044.293.964.964,0,0,1-.125.249.732.732,0,0,1-.2.189.635.635,0,0,1-.257.1l.687,1.077h-.314l-.655-1.029h-.828v1.029Zm.273-1.274h.912a.466.466,0,0,0,.225-.052.531.531,0,0,0,.169-.145.721.721,0,0,0,.113-.2.769.769,0,0,0,.04-.237.651.651,0,0,0-.048-.245.607.607,0,0,0-.3-.338.466.466,0,0,0-.217-.052h-.892Z",
    transform: "translate(-334.74 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510124",
    "data-name": "Path 510124",
    d: "M488.19,161.573V158.78h.277v2.793Z",
    transform: "translate(-338.561 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510125",
    "data-name": "Path 510125",
    d: "M529.615,159.272a.832.832,0,0,0-.317-.213,1.117,1.117,0,0,0-.446-.084.86.86,0,0,0-.543.141.467.467,0,0,0-.169.378.4.4,0,0,0,.185.35,1.1,1.1,0,0,0,.245.1l.346.088a3.137,3.137,0,0,1,.4.1,1.11,1.11,0,0,1,.3.149.622.622,0,0,1,.2.213.671.671,0,0,1,.064.313.749.749,0,0,1-.072.338.684.684,0,0,1-.209.233.9.9,0,0,1-.321.141,1.58,1.58,0,0,1-.4.044,1.68,1.68,0,0,1-1.125-.4l.141-.225a1.117,1.117,0,0,0,.177.149,1.343,1.343,0,0,0,.506.2,1.513,1.513,0,0,0,.305.032.956.956,0,0,0,.522-.121.431.431,0,0,0-.024-.735,1.167,1.167,0,0,0-.265-.113c-.1-.032-.225-.064-.366-.1s-.273-.068-.4-.1a1.115,1.115,0,0,1-.277-.137.587.587,0,0,1-.173-.2.669.669,0,0,1-.056-.285.8.8,0,0,1,.072-.346.651.651,0,0,1,.2-.249.931.931,0,0,1,.318-.153,1.386,1.386,0,0,1,.4-.056,1.354,1.354,0,0,1,.494.084,1.257,1.257,0,0,1,.4.241Z",
    transform: "translate(-362.223 -126.333)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510126",
    "data-name": "Path 510126",
    d: "M534.548,158.78h.233l1.162,2.793h-.31l-.362-.872h-1.246l-.358.872h-.3Zm.683,1.7-.563-1.378-.575,1.378Z",
    transform: "translate(-365.584 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510127",
    "data-name": "Path 510127",
    d: "M541.627,159.025h-1v2.548h-.273v-2.548h-1v-.245h2.267Z",
    transform: "translate(-369.167 -126.363)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204070",
    "data-name": "Rectangle 204070",
    width: 11.996,
    height: 0.932,
    transform: "translate(54.947 41.282)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204071",
    "data-name": "Rectangle 204071",
    width: 6.788,
    height: 0.932,
    transform: "translate(54.947 43.328)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204072",
    "data-name": "Rectangle 204072",
    width: 11.996,
    height: 0.932,
    transform: "translate(76.356 125.668)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204073",
    "data-name": "Rectangle 204073",
    width: 6.788,
    height: 0.932,
    transform: "translate(76.356 127.709)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204074",
    "data-name": "Rectangle 204074",
    width: 11.996,
    height: 0.932,
    transform: "translate(119.446 104.187)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204075",
    "data-name": "Rectangle 204075",
    width: 6.282,
    height: 0.932,
    transform: "translate(119.446 108.278)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204076",
    "data-name": "Rectangle 204076",
    width: 8.649,
    height: 0.932,
    transform: "translate(119.446 106.232)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204077",
    "data-name": "Rectangle 204077",
    width: 6.282,
    height: 0.932,
    transform: "translate(76.05 87.383)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204078",
    "data-name": "Rectangle 204078",
    width: 8.649,
    height: 0.932,
    transform: "translate(76.05 85.342)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510128",
    "data-name": "Path 510128",
    d: "M342.708,287.91l-.048-.1C342.76,288.023,342.7,287.906,342.708,287.91Z",
    transform: "translate(-251.519 -203.537)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510129",
    "data-name": "Path 510129",
    d: "M344.7,293.42l-.012-.04.08.334Z",
    transform: "translate(-252.733 -206.869)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510130",
    "data-name": "Path 510130",
    d: "M345.15,296.739a6.512,6.512,0,0,0-.048-1.165v-.064a1.248,1.248,0,0,0-.032-.169,7.741,7.741,0,0,1,.08,1.4Z",
    transform: "translate(-252.96 -208.041)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510131",
    "data-name": "Path 510131",
    d: "M344.87,301.261c.02-.068-.032.245.048-.261v.048A1.151,1.151,0,0,0,344.87,301.261Z",
    transform: "translate(-252.841 -211.426)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510132",
    "data-name": "Path 510132",
    d: "M344.99,301.009C345.03,300.784,344.961,301.154,344.99,301.009Z",
    transform: "translate(-252.908 -211.387)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510133",
    "data-name": "Path 510133",
    d: "M344.3,303.215a2.273,2.273,0,0,0,.076-.285,1.263,1.263,0,0,1-.072.217C344.215,303.436,344.239,303.38,344.3,303.215Z",
    transform: "translate(-252.467 -212.581)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510134",
    "data-name": "Path 510134",
    d: "M344.21,304.1l.044-.145a.7.7,0,0,0-.044.145Z",
    transform: "translate(-252.446 -213.197)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510135",
    "data-name": "Path 510135",
    d: "M344.412,303.18l-.092.313a.43.43,0,0,0,.04-.145C344.36,303.377,344.372,303.313,344.412,303.18Z",
    transform: "translate(-252.512 -212.73)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510136",
    "data-name": "Path 510136",
    d: "M344.67,302.018c.04-.161.1-.37.032-.076a2.1,2.1,0,0,0,.072-.4C344.771,301.58,344.738,301.725,344.67,302.018Z",
    transform: "translate(-252.721 -211.749)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510137",
    "data-name": "Path 510137",
    d: "M345.307,298.478v-.418C345.315,298.156,345.3,298.494,345.307,298.478Z",
    transform: "translate(-253.1 -209.668)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510138",
    "data-name": "Path 510138",
    d: "M342.4,307.351c0,.02.064-.076.084-.092l.1-.189C342.529,307.162,342.416,307.343,342.4,307.351Z",
    transform: "translate(-251.363 -215.057)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510139",
    "data-name": "Path 510139",
    d: "M342.347,307.538a2.544,2.544,0,0,1-.177.281C342.347,307.582,342.355,307.526,342.347,307.538Z",
    transform: "translate(-251.226 -215.336)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510140",
    "data-name": "Path 510140",
    d: "M344.166,303.692l.153-.522c-.064.2-.113.4-.189.619Z",
    transform: "translate(-252.398 -212.724)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510141",
    "data-name": "Path 510141",
    d: "M340.316,309.975l.117-.145-.213.253Z",
    transform: "translate(-250.06 -216.708)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510142",
    "data-name": "Path 510142",
    d: "M338.246,311.557c.092-.1-.157.1-.056,0l-.45.378C337.869,311.823,338.033,311.718,338.246,311.557Z",
    transform: "translate(-248.576 -217.724)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510143",
    "data-name": "Path 510143",
    d: "M337.14,312.737a2.716,2.716,0,0,0,.229-.177C337.3,312.62,337.216,312.673,337.14,312.737Z",
    transform: "translate(-248.217 -218.34)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510144",
    "data-name": "Path 510144",
    d: "M341.061,309.34a1.424,1.424,0,0,0-.181.185l.1-.084Z",
    transform: "translate(-250.454 -216.414)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510145",
    "data-name": "Path 510145",
    d: "M340.855,309.58h0a1.974,1.974,0,0,1-.185.2A2.2,2.2,0,0,0,340.855,309.58Z",
    transform: "translate(-250.329 -216.558)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510146",
    "data-name": "Path 510146",
    d: "M341.35,309.28l-.02.024Z",
    transform: "translate(-250.723 -216.379)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510147",
    "data-name": "Path 510147",
    d: "M343.08,306.42c-.072.181-.281.526-.068.2C343.072,306.492,342.951,306.689,343.08,306.42Z",
    transform: "translate(-251.673 -214.668)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510148",
    "data-name": "Path 510148",
    d: "M341.68,308.539c.072-.088.137-.185.209-.281,0,0-.052.052,0-.028C341.809,308.334,341.752,308.439,341.68,308.539Z",
    transform: "translate(-250.933 -215.751)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510149",
    "data-name": "Path 510149",
    d: "M341.42,309.137l.1-.137-.084.1Z",
    transform: "translate(-250.777 -216.211)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510150",
    "data-name": "Path 510150",
    d: "M337.772,312.049a4.951,4.951,0,0,1-.4.305c.173-.1.33-.237.49-.354C337.88,311.98,337.941,311.916,337.772,312.049Z",
    transform: "translate(-248.355 -217.986)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510151",
    "data-name": "Path 510151",
    d: "M339.754,311l-.024.024Z",
    transform: "translate(-249.766 -217.407)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510152",
    "data-name": "Path 510152",
    d: "M333.39,315.1l.028-.008,0-.008Z",
    transform: "translate(-245.974 -219.848)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510153",
    "data-name": "Path 510153",
    d: "M338.627,311.677a1.776,1.776,0,0,0,.241-.217,3.233,3.233,0,0,1-.269.233S338.591,311.709,338.627,311.677Z",
    transform: "translate(-249.089 -217.682)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510154",
    "data-name": "Path 510154",
    d: "M336.08,313.5a1.825,1.825,0,0,0,.225-.125Z",
    transform: "translate(-247.583 -218.831)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510155",
    "data-name": "Path 510155",
    d: "M339.6,311.12h0C339.573,311.132,339.581,311.132,339.6,311.12Z",
    transform: "translate(-249.678 -217.479)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510156",
    "data-name": "Path 510156",
    d: "M339.411,311.078l-.141.141.185-.169Z",
    transform: "translate(-249.491 -217.437)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510157",
    "data-name": "Path 510157",
    d: "M331.694,315.353a4.479,4.479,0,0,1,.7-.322c.3-.161.068-.129-.213-.04l-.317.161c.121-.02.715-.277.458-.141a2.54,2.54,0,0,1-.563.217c.1-.024-.036.04-.181.113s-.3.129-.245.137c.129-.048.253-.1.378-.157C331.718,315.324,331.594,315.389,331.694,315.353Z",
    transform: "translate(-244.737 -219.75)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510158",
    "data-name": "Path 510158",
    d: "M334.061,314.292l.125-.072a2.958,2.958,0,0,1-.454.193,1.7,1.7,0,0,0-.261.153c.209-.1.426-.193.631-.3Z",
    transform: "translate(-246.022 -219.333)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510159",
    "data-name": "Path 510159",
    d: "M335.777,313.131c-.076.088-.374.257-.177.177a3.8,3.8,0,0,0,.442-.317c-.563.374.153-.113-.261.141l.3-.2-.3.181h0l-.02.024c-.165.1-.028,0,.02-.024h0c-.181.133-.4.229-.575.346A5.018,5.018,0,0,0,335.777,313.131Z",
    transform: "translate(-247.063 -218.562)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510160",
    "data-name": "Path 510160",
    d: "M342.727,307.74h0C342.691,307.8,342.687,307.812,342.727,307.74Z",
    transform: "translate(-251.542 -215.457)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510161",
    "data-name": "Path 510161",
    d: "M342.011,307.75c.024-.044.052-.088.133-.213h0c.044-.084.161-.3,0-.04l-.024.04a4.662,4.662,0,0,1-.35.458,2.77,2.77,0,0,0,.241-.245Z",
    transform: "translate(-250.987 -215.239)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510162",
    "data-name": "Path 510162",
    d: "M339.132,311.22c-.141.125-.269.261-.4.378a2.443,2.443,0,0,0,.229-.173h0C339.168,311.216,339.108,311.256,339.132,311.22Z",
    transform: "translate(-249.168 -217.539)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510163",
    "data-name": "Path 510163",
    d: "M332.889,315.072l.056-.052-.285.153Z",
    transform: "translate(-245.538 -219.812)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510164",
    "data-name": "Path 510164",
    d: "M331.3,315.768l.016-.028-.177.072Z",
    transform: "translate(-244.629 -220.242)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510165",
    "data-name": "Path 510165",
    d: "M341.39,288l.113.133Z",
    transform: "translate(-250.759 -203.651)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510166",
    "data-name": "Path 510166",
    d: "M339.356,285.56h-.036C339.368,285.588,339.388,285.6,339.356,285.56Z",
    transform: "translate(-249.521 -202.191)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510167",
    "data-name": "Path 510167",
    d: "M296.82,300.483c.04-.237.1-.494.052-.466l-.04.068A2.945,2.945,0,0,1,296.82,300.483Z",
    transform: "translate(-224.102 -210.837)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510168",
    "data-name": "Path 510168",
    d: "M315.605,280.84h-.072l-.153.076Z",
    transform: "translate(-235.202 -199.368)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510169",
    "data-name": "Path 510169",
    d: "M316.26,280.236l.326-.036Z",
    transform: "translate(-235.729 -198.986)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510170",
    "data-name": "Path 510170",
    d: "M343.776,304.15l-.036.209C343.844,304.058,343.788,304.182,343.776,304.15Z",
    transform: "translate(-252.165 -213.31)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510171",
    "data-name": "Path 510171",
    d: "M312.432,317.694c-.2-.028-.362-.08-.5-.1A1.382,1.382,0,0,0,312.432,317.694Z",
    transform: "translate(-233.139 -221.349)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510172",
    "data-name": "Path 510172",
    d: "M339.739,287.71c.068.068.1.1.109.088C339.775,287.726,339.731,287.685,339.739,287.71Z",
    transform: "translate(-249.771 -203.473)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510173",
    "data-name": "Path 510173",
    d: "M310.49,317.28l.1.04c.145.024.3.044.474.084A4.736,4.736,0,0,0,310.49,317.28Z",
    transform: "translate(-232.278 -221.163)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510174",
    "data-name": "Path 510174",
    d: "M298.077,299.392v-.052A.166.166,0,0,0,298.077,299.392Z",
    transform: "translate(-224.852 -210.433)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510175",
    "data-name": "Path 510175",
    d: "M307.015,285.57l-.245.145Z",
    transform: "translate(-230.053 -202.197)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510176",
    "data-name": "Path 510176",
    d: "M324.44,317.471C324.593,317.443,324.464,317.471,324.44,317.471Z",
    transform: "translate(-240.621 -221.27)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510177",
    "data-name": "Path 510177",
    d: "M326.256,317.46c-.032,0-.056,0-.056.024a.193.193,0,0,1,.056-.024Z",
    transform: "translate(-241.674 -221.271)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510178",
    "data-name": "Path 510178",
    d: "M306.7,316.55Z",
    transform: "translate(-230.011 -220.727)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510179",
    "data-name": "Path 510179",
    d: "M324.707,317.43l-.2.024Z",
    transform: "translate(-240.663 -221.253)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510180",
    "data-name": "Path 510180",
    d: "M324.93,317.379l.137-.02S325.067,317.35,324.93,317.379Z",
    transform: "translate(-240.914 -221.21)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510181",
    "data-name": "Path 510181",
    d: "M323.91,317.522l.249-.032h-.036Z",
    transform: "translate(-240.304 -221.289)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510182",
    "data-name": "Path 510182",
    d: "M319.976,316.77h-.032C319.787,316.8,319.856,316.79,319.976,316.77Z",
    transform: "translate(-237.878 -220.858)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510183",
    "data-name": "Path 510183",
    d: "M298.41,291.26h0v-.02Z",
    transform: "translate(-225.053 -205.589)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510184",
    "data-name": "Path 510184",
    d: "M298.711,290a2.178,2.178,0,0,1-.281.5l.209-.092A2.117,2.117,0,0,1,298.711,290Z",
    transform: "translate(-225.065 -204.847)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510185",
    "data-name": "Path 510185",
    d: "M315.354,285.549l-.06-.4c.2.462.213.832.2.434a3.215,3.215,0,0,1-.289-.784c-.121-.4-.3-.743-.37-.743-.024-.088-.06-.169-.092-.253l.08.145c-.177-.5-.253-.305-.587-.884-.129-.2-.2-.342-.1-.221a4.026,4.026,0,0,0-.342-.4c-.1-.121-.052-.109.04,0l-.257-.305-.281-.281h0c-.092-.072-.305-.221-.4-.289-.137-.149.084.056.06,0-.121-.084-.233-.181-.358-.257-.117-.141.193.052.4.265-.221-.374-.281-.233-.969-.8a2.95,2.95,0,0,1,.358.221,1.315,1.315,0,0,0-.346-.309c-.145-.1-.309-.217-.514-.35.1.064.752.6.326.374a1.964,1.964,0,0,0-.5-.269c.024-.044-.2-.161-.494-.277l.044-.052a1.7,1.7,0,0,0-.506-.117,1.085,1.085,0,0,1-.49-.277c-.587-.169.4.189-.313,0a3.411,3.411,0,0,0-.675-.161,5.6,5.6,0,0,0-.764-.068c-.346-.064.064-.036-.056-.068l-.313.02c-.076,0-.052-.02-.04-.028-.261,0-.024.064-.434.064a8.435,8.435,0,0,0-1.346,0c-.125,0,.056-.044.02-.068a5.942,5.942,0,0,0-1.145.245,2.455,2.455,0,0,0-.486.032c.358-.02-.08.125-.454.257h.309l-.607.161c-.076,0-.02-.028.072-.076l-.108.04c-.221.032-.121-.04.028-.113h.233c.145-.072.277-.145.237-.177s-.113.036-.2.06c.036-.02.06-.036.04-.04a1.254,1.254,0,0,0-.185.064l-.157-.044-.028.036-.8.169c-.551.241-1.009.5-1.853.908.193-.141,0-.1,0-.165a1.8,1.8,0,0,0,.486-.193,3.159,3.159,0,0,1,.647-.269c-.245.072-.2.028-.145,0a7.986,7.986,0,0,0-.8.382c0-.052-.193.024-.4.117.2.024-.563.342-.84.575-.032,0,0-.109.4-.305-.466.161-.47.426-.9.619.084-.064.141-.084.165-.125-.2.153-.683.514-.591.4l.084-.064a4.2,4.2,0,0,0-.5.4,5.521,5.521,0,0,0-.514.5,2.287,2.287,0,0,0-.526.735.4.4,0,0,1,0-.185,8.213,8.213,0,0,0-.462,1.206c0-.129-.378.153-.113-.374a2.661,2.661,0,0,0-.346.651c.06-.1.225-.209.157-.068a3.564,3.564,0,0,0-.434.719c.084-.157.1.06.024.313,0-.044-.113,0-.1-.113-.024.233-.064.458-.076.687,0-.173-.084-.052-.145.092.032-.068-.121.579-.113.764l.056-.285a6.3,6.3,0,0,0,.1,1.511c-.032-.088-.157-.217-.137.173.032.084.112.273.229.51a8.024,8.024,0,0,1,.346.832v.129l.209.45a5.461,5.461,0,0,1-.76-1.535,2.28,2.28,0,0,0,.056.51c0,.161-.088-.221-.109-.35a7.138,7.138,0,0,0,.225,1c.04-.064.33.7.374.643A7.487,7.487,0,0,1,296,289.8c.024-.028.109.113.213.342s.253.539.4.852c.06.169-.157-.072-.169-.052a2.622,2.622,0,0,0,.193.33c.08.145.173.277.181.309-.06-.08-.129-.157-.185-.241.189.354.4.518.643.924.088.137.257.426.305.422-.133-.245,0-.4.157-.322l.277.362c.145.173.313.346.37.422.165.217-.4-.173-.241,0a1.052,1.052,0,0,1,.193.117c.121.121-.1,0,.2.221.088,0,.607.454.173.064.3.2.305.237.671.454-.048-.048.052-.028.2.028s.362.117.522.189c-.024,0,.04.056.072.084.33.153.6.245.856.354a4.649,4.649,0,0,0,.856.241c.06.024.4.1.237.1a3.241,3.241,0,0,1,.4.044c.4.112-.466-.072-.169.036.032,0,.555.032.856.04a9.628,9.628,0,0,0-.993-.121c0-.032.141-.044.362-.032s.53,0,.884.024c.563,0,.241.048.342.04a4.311,4.311,0,0,0,.961-.044,5.355,5.355,0,0,1,.824-.056c.354,0,.02.076.1.1-.458.056-.711,0-1.025.028h.4a5.222,5.222,0,0,1-.627.032,21.405,21.405,0,0,0,2.624-.157c.145-.028.4-.088.273-.08l-.257.044c-.241,0,.478-.113.153-.076.338-.084.719-.157,1.206-.257l.1.02a2.415,2.415,0,0,0-.45.088,7.041,7.041,0,0,0,.952-.217c-.113.02-.225.044-.342.056l1.153-.374c-.2.024-.088.044-.4.084.273,0-1.069.281-.639.229-.322,0-.539.1-.952.129,0,0,.149,0-.209.052l-.076.024h0a1.169,1.169,0,0,1,.189,0,8.471,8.471,0,0,1-.94.181c-.213,0,.088-.024-.028-.024l-.289.056c-.032-.024-.575,0-.072-.06-.153.02-.305.024-.454.036-.273,0-.639.024-.868.036s-.543.052-.358.024a7.049,7.049,0,0,1-.711.02h-.534c-.181,0-.362-.028-.551-.044a5.745,5.745,0,0,1-1.133-.217,7,7,0,0,1-.836-.241l-.064-.056c-.141-.052-.35-.133-.535-.217a2.433,2.433,0,0,0-.4-.193c-.133-.1-.43-.3-.76-.494l-.466-.342a3.954,3.954,0,0,1-.362-.318l-.044.02a4.932,4.932,0,0,1-.4-.382,4.2,4.2,0,0,1-.4-.454v.048a5.691,5.691,0,0,1-.8-1.4,1.254,1.254,0,0,1,.137.277,7.6,7.6,0,0,1-.635-2.106,2.155,2.155,0,0,1-.032-.4v-.257a.8.8,0,0,0,0,.193c-.02-.125,0-.322-.024-.51l.048-.08v-.04c0-.185,0-.153-.06-.056V287.4c.088-.141.02-.5.153-.687-.036-.141.2-.932.165-1.057,0,0,.04-.052,0,.044a3.724,3.724,0,0,0,.225-.579l.1-.056.141-.45c.165-.233.261-.313.149-.056a8.89,8.89,0,0,1,.555-.985v.048a2.546,2.546,0,0,1,.4-.514c.1-.072.233-.221.43-.382a8.345,8.345,0,0,1,.7-.563,7.981,7.981,0,0,1,1.736-1c-.261,0,.53-.169.539-.269.076,0,.233-.048.064.048a4.368,4.368,0,0,1,.691-.249,3.97,3.97,0,0,0,.559-.213c.072,0-.117.072-.052.072a1.035,1.035,0,0,1,.245-.072c.064,0-.076.044-.169.084.6-.165.639-.269.663-.362a1.834,1.834,0,0,0,.687-.169c.113,0,.3,0-.08.084.213-.06,1.318-.181,1.334-.245a1.758,1.758,0,0,0,.362-.032c.486-.044.531-.028,1.013-.044h-.137c.193-.092.4-.028.8,0h0c.442.044.535.068.631.068a2.413,2.413,0,0,1,.615.109l-.04-.06c.048-.044.241,0,.478.076a7.334,7.334,0,0,0,.764.245,1.255,1.255,0,0,0-.165-.08,3.86,3.86,0,0,1,.924.51c.052.032-.092-.024-.169-.052.627.35.117-.032.6.189.072.076-.153,0,.161.193a5.072,5.072,0,0,1,1.286.8c-.064-.092-.129-.185.072-.036.309.233.667.8.944,1,.028.044.032.06.028.068.1.113.245.3.378.474a4.966,4.966,0,0,0,.313.422,4.018,4.018,0,0,0,.4.936c.169.4.285.76.209.776a3.852,3.852,0,0,1,.1.438,4.056,4.056,0,0,1,.068.442v-.024c.024.285.044.474.056.627s.032.241.048.35-.024.036-.032.024a4.112,4.112,0,0,1-.056.5c-.02.137-.028.249-.048.35-.032.213-.048.4-.121.756l-.068.056a3.361,3.361,0,0,1-.322.707,6.094,6.094,0,0,1-.334.51,6.347,6.347,0,0,1-.358.526s0-.028.044-.08c-.535.78-1.7,1.395-1.9,1.7l-.249.185-.265.161c.719-.362-.072.117.233,0-.277.157-.752.334-.4.149l.06-.024c.044-.068-.181.04-.4.157a1.5,1.5,0,0,1-.5.181,14.363,14.363,0,0,1-4.529.985l.173.044-.514.04c-.137,0-.185-.032.185-.06a3.519,3.519,0,0,0-.627.068c-.723,0,.281-.068.06-.068h-.233a2.853,2.853,0,0,1-.707.044c-.281-.028-.145-.044-.253-.052a.666.666,0,0,0-.169,0,3.907,3.907,0,0,1-.647-.056c.084.024.169.052.253.068-.289,0-.6-.084-.313,0-.213-.072-.8-.145-1.382-.3a4.991,4.991,0,0,1-.776-.229l-.446-.157a4.8,4.8,0,0,1-1.141-.595c.1.076.137.153-.213-.092.044,0,.028-.024-.024-.068a1.893,1.893,0,0,1-.229-.209,3.709,3.709,0,0,1-.5-.547c.157.265-.739-.944-.49-.535-.177-.309,0-.032-.108-.273a5.908,5.908,0,0,1-.872-2.733s0,.161-.036-.06v-.277l.028-.273a3.172,3.172,0,0,1,0-.567c0,.052-.02.133,0,0a7.19,7.19,0,0,1,1.013-2.926l.446-.651.543-.579a3.843,3.843,0,0,1,.591-.522,6.437,6.437,0,0,1,.631-.47c-.249.141-.084.044.1-.068-.121.072,0,0-.024,0l.756-.446c.133-.092.86-.382.94-.426l-.253.113c.338-.149-.482.2-.434.169a5.837,5.837,0,0,0-.7.37,4.379,4.379,0,0,0-.828.535c-.121.088.1-.084.032-.036-.133.113-.3.241-.6.474l.032-.028a7.3,7.3,0,0,0-1.708,2.178l.036-.044-.213.4c-.117.277.342-.663.237-.4a7.413,7.413,0,0,0-.7,1.969c-.072.4.044-.113-.028.285a.54.54,0,0,0-.028.108v.1a1.777,1.777,0,0,1-.048.4v-.257c0,.173-.028.4-.032.635a2.722,2.722,0,0,0,.044.462l-.024-.4c.028.277.048.571.088.868a6.991,6.991,0,0,0,.209.892,5.563,5.563,0,0,0,.338.848,5.67,5.67,0,0,0,.43.739.266.266,0,0,1-.036-.076,6.459,6.459,0,0,0,1.013,1.206l-.028-.02c.072.052.145.133.241.2l.3.2c-.2-.117.338.273.08.117a2.029,2.029,0,0,0,.555.3c.072.024.108.028.382.133l.113.084a5.411,5.411,0,0,1,.639.185c-.354-.1.257.133-.141.02a4.381,4.381,0,0,0,1.065.309c.281.064.5.088.707.161.221,0,.02-.044-.2-.08a1.141,1.141,0,0,1-.35-.076c-.1-.036,0-.028.145,0s.362.04.506.068a5.774,5.774,0,0,0,1.246.225h-.157c.285.04.555,0,.9.04.193-.048.45,0,.506-.06h-.7c.4-.024.76-.064,1.407-.092-.052,0-.241.044-.374.064.189,0,.362-.04.559-.036a6.835,6.835,0,0,1-1.258.117c.2.028.8-.052.587,0,.3-.113.747-.032,1.25-.161l-.028.044a3.67,3.67,0,0,1,.4-.08l-.261.088c.4-.113.8-.06,1.206-.185-.8.169-.193,0-.543.028a3.86,3.86,0,0,1,.8-.133,2.668,2.668,0,0,0,.908-.177c-.149.052-.571.145-.342.056a2.752,2.752,0,0,1,.635-.141c.731-.233-.129,0,.177-.129.269-.02.346-.145.651-.281l.02.04c.8-.305.189-.145.9-.466l-.269.2.358-.2-.052.084c.382-.241.518-.277.892-.514-.1.028,0-.1.326-.309.233-.133-.084.133.346-.209a.8.8,0,0,1-.4.309c0,.024-.088.088-.1.113a3.054,3.054,0,0,0,.4-.257l.326-.281a2.087,2.087,0,0,1-.173.129c.193-.189.4-.37.575-.563.1-.08.044,0-.024.08.117-.112.173-.217.334-.4,0,.068.024.084-.2.35l.494-.6c.056,0,.277-.285.229-.2a6.943,6.943,0,0,0,.4-.651c.129-.249.249-.526.362-.8a1.566,1.566,0,0,1,.056-.2,4.542,4.542,0,0,0,.33-1.608l.084-.358c0-.5-.076.482-.121-.342-.048-.579.048-.221.052-.426-.056-.289-.2-.772-.293-1.3A4.351,4.351,0,0,1,315.354,285.549Zm-3.472-4.823a1.643,1.643,0,0,1,.374.225.836.836,0,0,1-.374-.209Zm-8.842-.655a1.375,1.375,0,0,1,.358-.084,2.474,2.474,0,0,1-.354.1Zm2.6,14.842Zm.526-.024h.028a1.992,1.992,0,0,1-.289.028.892.892,0,0,0,.261-.036Zm-2.222-.723h.1c-.233,0-.169,0-.109-.008Z",
    transform: "translate(-223.509 -198.507)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510186",
    "data-name": "Path 510186",
    d: "M316.22,280.344a.08.08,0,0,1,.052,0C316.316,280.344,316.316,280.335,316.22,280.344Z",
    transform: "translate(-235.705 -199.069)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510187",
    "data-name": "Path 510187",
    d: "M343.85,304.06Z",
    transform: "translate(-252.231 -213.256)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510188",
    "data-name": "Path 510188",
    d: "M301.785,313.831a.994.994,0,0,1-.145-.161A.574.574,0,0,0,301.785,313.831Z",
    transform: "translate(-226.984 -219.004)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510189",
    "data-name": "Path 510189",
    d: "M327.862,316.7c-.1.032-.213.056-.322.08.157-.036.217-.036.3-.052C327.825,316.72,327.761,316.728,327.862,316.7Z",
    transform: "translate(-242.475 -220.817)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510190",
    "data-name": "Path 510190",
    d: "M335.15,314.44l.133-.08h0C335.081,314.46,334.961,314.545,335.15,314.44Z",
    transform: "translate(-246.97 -219.417)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510191",
    "data-name": "Path 510191",
    d: "M329.16,316.551a1.751,1.751,0,0,0,.458-.117h-.04C329.634,316.394,329.4,316.474,329.16,316.551Z",
    transform: "translate(-243.444 -220.651)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510192",
    "data-name": "Path 510192",
    d: "M330.43,316.289l.2-.068C330.659,316.2,330.551,316.245,330.43,316.289Z",
    transform: "translate(-244.204 -220.526)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510193",
    "data-name": "Path 510193",
    d: "M322.85,317.646c.113,0,.064-.04.129-.036S322.243,317.734,322.85,317.646Z",
    transform: "translate(-239.533 -221.36)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510194",
    "data-name": "Path 510194",
    d: "M329.353,316.8l-.088-.008-.125.06Z",
    transform: "translate(-243.432 -220.87)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510195",
    "data-name": "Path 510195",
    d: "M325.109,317.65l.378-.052a.238.238,0,0,0,.1-.028C325.354,317.606,325.1,317.642,325.109,317.65Z",
    transform: "translate(-241.021 -221.337)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510196",
    "data-name": "Path 510196",
    d: "M326.29,317.462c.121-.024.233-.052.3-.072Z",
    transform: "translate(-241.728 -221.229)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510197",
    "data-name": "Path 510197",
    d: "M327.88,317.18l-.109.02-.261.056Z",
    transform: "translate(-242.458 -221.104)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510198",
    "data-name": "Path 510198",
    d: "M314.387,318.358a1.86,1.86,0,0,1-.4-.028c-.044,0,.068.032.221.04S314.452,318.37,314.387,318.358Z",
    transform: "translate(-234.363 -221.791)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510199",
    "data-name": "Path 510199",
    d: "M317.851,318.634a.749.749,0,0,1-.181-.024v.048Z",
    transform: "translate(-236.572 -221.959)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510200",
    "data-name": "Path 510200",
    d: "M314.651,318.69c-.04.024-.607,0-.076.032C314.611,318.71,315.037,318.71,314.651,318.69Z",
    transform: "translate(-234.586 -222.007)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510201",
    "data-name": "Path 510201",
    d: "M301.06,312.7l.072.076.052-.072Z",
    transform: "translate(-226.638 -218.424)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510202",
    "data-name": "Path 510202",
    d: "M295.574,300.164c-.02.51.048.121.04.579v-.129c0-.092,0-.185.02-.125C295.627,300.188,295.639,300.024,295.574,300.164Z",
    transform: "translate(-223.354 -210.896)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510203",
    "data-name": "Path 510203",
    d: "M295.76,301.05v0Z",
    transform: "translate(-223.468 -211.456)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510204",
    "data-name": "Path 510204",
    d: "M309.92,284.049l.289-.129-.189.08Z",
    transform: "translate(-231.937 -201.211)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510205",
    "data-name": "Path 510205",
    d: "M311.3,283.474l.068-.028.173-.076Z",
    transform: "translate(-232.762 -200.882)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510206",
    "data-name": "Path 510206",
    d: "M333.9,281.35h-.028a2.523,2.523,0,0,0,.241.145A2.057,2.057,0,0,0,333.9,281.35Z",
    transform: "translate(-246.261 -199.673)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510207",
    "data-name": "Path 510207",
    d: "M342.04,288.614l-.04-.064.024.153Z",
    transform: "translate(-251.124 -203.98)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510208",
    "data-name": "Path 510208",
    d: "M345.022,296.76c0-.157-.04-.334-.052-.49C345.022,296.6,344.954,296.8,345.022,296.76Z",
    transform: "translate(-252.901 -208.597)",
    fill: "#3e494e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204079",
    "data-name": "Rectangle 204079",
    width: 9.939,
    height: 15.3,
    transform: "translate(0 7.061)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204080",
    "data-name": "Rectangle 204080",
    width: 9.939,
    height: 15.3,
    transform: "translate(0 7.061)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204081",
    "data-name": "Rectangle 204081",
    width: 0.201,
    height: 126.524,
    transform: "translate(0.663 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204082",
    "data-name": "Rectangle 204082",
    width: 0.201,
    height: 126.524,
    transform: "translate(1.865 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204083",
    "data-name": "Rectangle 204083",
    width: 0.201,
    height: 126.524,
    transform: "translate(3.066 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204084",
    "data-name": "Rectangle 204084",
    width: 0.201,
    height: 126.524,
    transform: "translate(4.268 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204085",
    "data-name": "Rectangle 204085",
    width: 0.201,
    height: 126.524,
    transform: "translate(5.474 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204086",
    "data-name": "Rectangle 204086",
    width: 0.201,
    height: 126.524,
    transform: "translate(6.675 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204087",
    "data-name": "Rectangle 204087",
    width: 0.201,
    height: 126.524,
    transform: "translate(7.877 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204088",
    "data-name": "Rectangle 204088",
    width: 0.201,
    height: 126.524,
    transform: "translate(9.083 22.361)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510209",
    "data-name": "Path 510209",
    d: "M177.8,108.046a2.612,2.612,0,1,1-.765-1.851A2.616,2.616,0,0,1,177.8,108.046Z",
    transform: "translate(-149.787 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510210",
    "data-name": "Path 510210",
    d: "M178.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,178.287,109.583Z",
    transform: "translate(-151.312 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16804",
    "data-name": "Ellipse 16804",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(36.436 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510211",
    "data-name": "Path 510211",
    d: "M212.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,212.287,109.583Z",
    transform: "translate(-171.648 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510212",
    "data-name": "Path 510212",
    d: "M245.743,108.046a2.616,2.616,0,1,1-2.616-2.616,2.616,2.616,0,0,1,2.616,2.616Z",
    transform: "translate(-190.422 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510213",
    "data-name": "Path 510213",
    d: "M246.287,109.583a1.583,1.583,0,1,1-.472-1.128A1.583,1.583,0,0,1,246.287,109.583Z",
    transform: "translate(-191.983 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510214",
    "data-name": "Path 510214",
    d: "M279.8,108.046a2.612,2.612,0,1,1-.765-1.851A2.616,2.616,0,0,1,279.8,108.046Z",
    transform: "translate(-210.794 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510215",
    "data-name": "Path 510215",
    d: "M280.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,280.287,109.583Z",
    transform: "translate(-212.319 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16805",
    "data-name": "Ellipse 16805",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(77.477 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510216",
    "data-name": "Path 510216",
    d: "M314.4,109.583A1.583,1.583,0,1,1,312.813,108,1.583,1.583,0,0,1,314.4,109.583Z",
    transform: "translate(-232.72 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16806",
    "data-name": "Ellipse 16806",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(91.097 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510217",
    "data-name": "Path 510217",
    d: "M348.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,348.287,109.583Z",
    transform: "translate(-252.99 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16807",
    "data-name": "Ellipse 16807",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(104.761 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510218",
    "data-name": "Path 510218",
    d: "M382.287,109.583A1.583,1.583,0,1,1,380.7,108a1.583,1.583,0,0,1,1.583,1.583Z",
    transform: "translate(-273.326 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16808",
    "data-name": "Ellipse 16808",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(118.47 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510219",
    "data-name": "Path 510219",
    d: "M416.4,109.583A1.583,1.583,0,1,1,414.813,108a1.583,1.583,0,0,1,1.583,1.583Z",
    transform: "translate(-293.727 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510220",
    "data-name": "Path 510220",
    d: "M449.8,108.046a2.616,2.616,0,1,1-2.616-2.616A2.616,2.616,0,0,1,449.8,108.046Z",
    transform: "translate(-312.472 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510221",
    "data-name": "Path 510221",
    d: "M450.287,109.583A1.583,1.583,0,1,1,448.7,108,1.583,1.583,0,0,1,450.287,109.583Z",
    transform: "translate(-313.997 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510222",
    "data-name": "Path 510222",
    d: "M483.853,108.046a2.612,2.612,0,1,1-.765-1.851A2.616,2.616,0,0,1,483.853,108.046Z",
    transform: "translate(-332.838 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510223",
    "data-name": "Path 510223",
    d: "M484.357,109.583a1.579,1.579,0,1,1-.463-1.121,1.583,1.583,0,0,1,.463,1.121Z",
    transform: "translate(-334.375 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510224",
    "data-name": "Path 510224",
    d: "M517.763,108.046A2.612,2.612,0,1,1,517,106.2,2.616,2.616,0,0,1,517.763,108.046Z",
    transform: "translate(-353.119 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510225",
    "data-name": "Path 510225",
    d: "M518.287,109.583a1.58,1.58,0,1,1-.471-1.13A1.584,1.584,0,0,1,518.287,109.583Z",
    transform: "translate(-354.669 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510226",
    "data-name": "Path 510226",
    d: "M551.813,108.046a2.612,2.612,0,1,1-.765-1.851A2.616,2.616,0,0,1,551.813,108.046Z",
    transform: "translate(-373.485 -94.454)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510227",
    "data-name": "Path 510227",
    d: "M552.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,552.287,109.583Z",
    transform: "translate(-375.004 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16809",
    "data-name": "Ellipse 16809",
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(186.751 10.976)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510228",
    "data-name": "Path 510228",
    d: "M586.287,109.583a1.579,1.579,0,1,1-.463-1.121A1.583,1.583,0,0,1,586.287,109.583Z",
    transform: "translate(-395.34 -95.991)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510229",
    "data-name": "Path 510229",
    d: "M166.825,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C165.185,78.12,166.825,80.66,166.825,86.182Z",
    transform: "translate(-140.139 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510230",
    "data-name": "Path 510230",
    d: "M200.831,86.182c0,1.306-.145,5.558-.145,5.558a1.142,1.142,0,0,1-2.283,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C199.191,78.12,200.831,80.66,200.831,86.182Z",
    transform: "translate(-160.481 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510231",
    "data-name": "Path 510231",
    d: "M234.829,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.845-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C233.185,78.12,234.829,80.66,234.829,86.182Z",
    transform: "translate(-180.811 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510232",
    "data-name": "Path 510232",
    d: "M268.835,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C267.2,78.12,268.835,80.66,268.835,86.182Z",
    transform: "translate(-201.152 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510233",
    "data-name": "Path 510233",
    d: "M302.835,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C301.2,78.12,302.835,80.66,302.835,86.182Z",
    transform: "translate(-221.488 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510234",
    "data-name": "Path 510234",
    d: "M336.839,86.182c0,1.306-.149,5.558-.149,5.558a1.142,1.142,0,0,1-2.283,0V85.254c0-3.271-1.427-4.449-2.845-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.431-7.057,4.939-7.057C335.2,78.12,336.839,80.66,336.839,86.182Z",
    transform: "translate(-241.824 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510235",
    "data-name": "Path 510235",
    d: "M370.839,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.845-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C369.2,78.12,370.839,80.66,370.839,86.182Z",
    transform: "translate(-262.159 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510236",
    "data-name": "Path 510236",
    d: "M404.845,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C403.205,78.12,404.845,80.66,404.845,86.182Z",
    transform: "translate(-282.501 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510237",
    "data-name": "Path 510237",
    d: "M438.849,86.182c0,1.306-.149,5.558-.149,5.558a1.142,1.142,0,0,1-2.283,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.943-7.057C437.205,78.12,438.849,80.66,438.849,86.182Z",
    transform: "translate(-302.837 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510238",
    "data-name": "Path 510238",
    d: "M472.849,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.845-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C471.209,78.12,472.849,80.66,472.849,86.182Z",
    transform: "translate(-323.172 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510239",
    "data-name": "Path 510239",
    d: "M506.855,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C505.215,78.12,506.855,80.66,506.855,86.182Z",
    transform: "translate(-343.514 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510240",
    "data-name": "Path 510240",
    d: "M540.859,86.182c0,1.306-.149,5.558-.149,5.558a1.142,1.142,0,0,1-2.283,0V85.254c0-3.271-1.423-4.449-2.841-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.435-7.057,4.939-7.057C539.215,78.12,540.859,80.66,540.859,86.182Z",
    transform: "translate(-363.85 -78.12)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510241",
    "data-name": "Path 510241",
    d: "M574.859,86.182c0,1.306-.145,5.558-.145,5.558a1.144,1.144,0,0,1-2.287,0V85.254c0-3.271-1.427-4.449-2.846-4.449-1.768,0-2.813,2.13-2.813,4.373h-2.3c0-5.092,2.436-7.057,4.939-7.057C573.219,78.12,574.859,80.66,574.859,86.182Z",
    transform: "translate(-384.185 -78.12)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12",
    transform: "translate(55.593 201.835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510242",
    "data-name": "Path 510242",
    d: "M60.33,448.3c81.021-.245,171.905-.249,252.927,0-81.021.249-171.905.245-252.927,0Z",
    transform: "translate(-60.33 -448.119)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-12",
    transform: "translate(130.851 113.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510243",
    "data-name": "Path 510243",
    d: "M375.109,244.168H359.436a8.391,8.391,0,0,1-.776-3.119V228.49h15.674v12.72A8.87,8.87,0,0,0,375.109,244.168Z",
    transform: "translate(-314.022 -228.209)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510244",
    "data-name": "Path 510244",
    d: "M365.36,237.416c1.841-.153,3.685-.189,5.53-.2s3.685.044,5.53.2c-1.845.153-3.685.185-5.53.193S367.2,237.564,365.36,237.416Z",
    transform: "translate(-318.029 -233.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510245",
    "data-name": "Path 510245",
    d: "M365.36,242.562c1.656-.153,3.316-.185,4.975-.193s3.316.04,4.971.193c-1.656.153-3.316.189-4.971.193S367.016,242.714,365.36,242.562Z",
    transform: "translate(-318.029 -236.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510246",
    "data-name": "Path 510246",
    d: "M365.36,247.712c1.451-.149,2.9-.185,4.348-.193a39.472,39.472,0,0,1,4.352.193c-1.451.153-2.9.189-4.352.2A40.508,40.508,0,0,1,365.36,247.712Z",
    transform: "translate(-318.029 -239.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510247",
    "data-name": "Path 510247",
    d: "M365.36,252.846c1.841-.153,3.685-.189,5.53-.2s3.685.044,5.53.2c-1.845.153-3.685.185-5.53.193S367.2,252.994,365.36,252.846Z",
    transform: "translate(-318.029 -242.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510248",
    "data-name": "Path 510248",
    d: "M320.2,348.674H304.526a8.4,8.4,0,0,1-.776-3.123V333h15.674v12.72A8.934,8.934,0,0,0,320.2,348.674Z",
    transform: "translate(-281.18 -290.717)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510249",
    "data-name": "Path 510249",
    d: "M310.45,341.9c1.841-.153,3.685-.189,5.53-.2s3.685.044,5.53.2c-1.845.149-3.685.185-5.53.193S312.279,342.044,310.45,341.9Z",
    transform: "translate(-285.187 -295.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510250",
    "data-name": "Path 510250",
    d: "M310.45,347.042c1.656-.153,3.316-.185,4.971-.193s3.32.04,4.975.193c-1.656.153-3.316.189-4.975.193S312.106,347.194,310.45,347.042Z",
    transform: "translate(-285.187 -298.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510251",
    "data-name": "Path 510251",
    d: "M310.45,352.182c1.447-.149,2.9-.185,4.349-.193a39.44,39.44,0,0,1,4.352.193c-1.451.153-2.9.189-4.352.2A39.305,39.305,0,0,1,310.45,352.182Z",
    transform: "translate(-285.187 -302.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510252",
    "data-name": "Path 510252",
    d: "M310.45,357.326c1.841-.153,3.685-.189,5.53-.2s3.685.044,5.53.2c-1.845.149-3.685.185-5.53.193S312.279,357.478,310.45,357.326Z",
    transform: "translate(-285.187 -305.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510253",
    "data-name": "Path 510253",
    d: "M264.043,243.468H248.37a8.364,8.364,0,0,1-.78-3.123V227.79h15.674v12.72A8.835,8.835,0,0,0,264.043,243.468Z",
    transform: "translate(-247.59 -227.79)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510254",
    "data-name": "Path 510254",
    d: "M254.29,236.706c1.845-.153,3.689-.189,5.534-.2s3.685.044,5.53.2c-1.845.149-3.689.185-5.53.193S256.135,236.858,254.29,236.706Z",
    transform: "translate(-251.597 -233.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510255",
    "data-name": "Path 510255",
    d: "M254.29,241.862c1.66-.153,3.32-.185,4.975-.193s3.316.04,4.975.193c-1.66.153-3.316.185-4.975.193S255.95,242.014,254.29,241.862Z",
    transform: "translate(-251.597 -236.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510256",
    "data-name": "Path 510256",
    d: "M254.29,247c1.451-.149,2.9-.185,4.352-.193a39.436,39.436,0,0,1,4.353.193c-1.451.153-2.9.189-4.353.2A39.429,39.429,0,0,1,254.29,247Z",
    transform: "translate(-251.597 -239.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510257",
    "data-name": "Path 510257",
    d: "M254.29,252.146c1.845-.153,3.689-.189,5.534-.2s3.685.044,5.53.2c-1.845.149-3.689.185-5.53.193S256.135,252.294,254.29,252.146Z",
    transform: "translate(-251.597 -242.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510258",
    "data-name": "Path 510258",
    d: "M424,400.938H411.539a21.732,21.732,0,0,1-.269-3.119V385.26h15.674v12.72C426.94,399.25,424,400.938,424,400.938Z",
    transform: "translate(-345.488 -321.974)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510259",
    "data-name": "Path 510259",
    d: "M445.888,416.85c0,1.238-2.765,2.853-2.938,2.954.458-.309.382-2.765.382-2.765A15.719,15.719,0,0,1,445.888,416.85Z",
    transform: "translate(-364.436 -340.848)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510260",
    "data-name": "Path 510260",
    d: "M417,394.186c1.841-.153,3.685-.189,5.53-.2s3.685.044,5.53.2c-1.845.153-3.685.185-5.53.193S418.841,394.334,417,394.186Z",
    transform: "translate(-348.915 -327.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510261",
    "data-name": "Path 510261",
    d: "M417,399.332c1.447-.153,2.9-.185,4.348-.193a39.424,39.424,0,0,1,4.352.193,42.6,42.6,0,0,1-4.352.193C419.9,399.517,418.447,399.484,417,399.332Z",
    transform: "translate(-348.915 -330.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510262",
    "data-name": "Path 510262",
    d: "M417,404.472c1.447-.149,2.9-.185,4.348-.193a40.443,40.443,0,0,1,4.352.193c-1.451.153-2.9.189-4.352.2A39.32,39.32,0,0,1,417,404.472Z",
    transform: "translate(-348.915 -333.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510263",
    "data-name": "Path 510263",
    d: "M529.418,295.278H516.959a21.828,21.828,0,0,1-.269-3.123V279.6h15.674v12.72C532.364,293.59,529.418,295.278,529.418,295.278Z",
    transform: "translate(-408.541 -258.778)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510264",
    "data-name": "Path 510264",
    d: "M551.314,311.188c0,1.238-2.765,2.853-2.934,2.954.458-.309.378-2.765.378-2.765A15.28,15.28,0,0,1,551.314,311.188Z",
    transform: "translate(-427.495 -277.65)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510265",
    "data-name": "Path 510265",
    d: "M522.42,288.526c1.841-.153,3.685-.189,5.53-.2s3.689.044,5.53.2c-1.841.149-3.685.185-5.53.193S524.261,288.674,522.42,288.526Z",
    transform: "translate(-411.968 -263.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510266",
    "data-name": "Path 510266",
    d: "M522.42,293.711c1.451-.153,2.9-.185,4.348-.193a42.6,42.6,0,0,1,4.353.193c-1.451.153-2.9.185-4.353.193S523.859,293.848,522.42,293.711Z",
    transform: "translate(-411.968 -267.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510267",
    "data-name": "Path 510267",
    d: "M522.42,298.812c1.451-.149,2.9-.185,4.348-.193a39.475,39.475,0,0,1,4.352.193c-1.451.153-2.9.189-4.352.2A39.217,39.217,0,0,1,522.42,298.812Z",
    transform: "translate(-411.968 -270.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-12",
    transform: "translate(269.408 143.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510268",
    "data-name": "Path 510268",
    d: "M649.22,365.218s6.768-1.531,10.477-4.951,5.779-9.537,5.779-9.537a57.782,57.782,0,0,0-7.588,2.009,12.746,12.746,0,0,0-2.3,3.247,15.68,15.68,0,0,1,0-2.323,10.428,10.428,0,0,0-2.411,1.463C650.088,357.8,649.22,365.218,649.22,365.218Z",
    transform: "translate(-626.364 -331.331)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510269",
    "data-name": "Path 510269",
    d: "M655.277,355.163c.92-.639,1.861-1.254,2.777-1.9a.052.052,0,0,0-.056-.088c-1.74,1.041-3.46,2.154-5.124,3.32-.579.4-1.149.828-1.712,1.258l.117-.2c.2-.342.4-.675.631-1.009a14.478,14.478,0,0,1,1.439-1.917c0-.02,0-.052-.032-.032-.526.607-1.053,1.206-1.535,1.853-.229.309-.442.623-.643.949-.1.169-.209.338-.305.51l-.1.177c-.876.687-1.728,1.4-2.54,2.162-.5.466-.985.952-1.455,1.451.261-.8.49-1.648.8-2.456,0-.024-.036-.036-.044,0-.3.844-.619,1.7-.848,2.564-.518.559-1.013,1.137-1.479,1.744l.024-.113q.116-.474.241-.952c.165-.611.346-1.206.551-1.821a10.57,10.57,0,0,1,1.821-3.432c0-.024,0-.056-.036-.032a13.231,13.231,0,0,0-2.6,5.4q-.109.434-.2.868c-.036.153-.076.309-.1.47-.2.273-.4.555-.6.84a29.425,29.425,0,0,0-2.861,5.626,64.214,64.214,0,0,0-2.17,6.76.036.036,0,0,0,.068.02,51,51,0,0,1,4.943-11.518c.478-.748,1-1.467,1.543-2.158a12.763,12.763,0,0,0,3.292-.659,14.44,14.44,0,0,0,3.3-1.608,19.206,19.206,0,0,0,1.688-1.278.021.021,0,0,0-.028-.032,13.621,13.621,0,0,1-3.1,1.877,16.688,16.688,0,0,1-3.412,1.141c-.5.113-1,.193-1.515.261a28.915,28.915,0,0,1,2.009-2.21c.229-.229.466-.446.7-.667a16.232,16.232,0,0,1,2.5-1.435c1.109-.534,2.2-1.1,3.3-1.66.619-.318,1.234-.639,1.857-.944.028,0,0-.052-.024-.036-1.113.535-2.243,1.037-3.364,1.551-1.057.486-2.126.973-3.139,1.539l-.129.076q1.374-1.206,2.837-2.291C653.441,356.465,654.349,355.8,655.277,355.163Z",
    transform: "translate(-620.389 -332.79)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510270",
    "data-name": "Path 510270",
    d: "M673.328,366.807c-.55.241-1.113.458-1.656.711a18.115,18.115,0,0,0-1.608.884c-.024,0,0,.044.024.032.539-.257,1.085-.5,1.608-.768s1.089-.567,1.648-.8C673.369,366.839,673.357,366.795,673.328,366.807Z",
    transform: "translate(-638.826 -340.945)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510271",
    "data-name": "Path 510271",
    d: "M594.52,302.46a9.69,9.69,0,0,1,2.009,5.626c.02.607-.076,1.451-.145,2.444a16.112,16.112,0,0,1,4.421,3.774,8.014,8.014,0,0,0-4.465-1.065,13.016,13.016,0,0,0,.261,2.009,7.6,7.6,0,0,1,2.87.567,6.431,6.431,0,0,0-2.588.514c1.206,3.838,4.79,7.781,14.693,9.452a20.766,20.766,0,0,0-1.756-13.93C606.866,306.025,594.52,302.46,594.52,302.46Z",
    transform: "translate(-593.648 -302.46)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510272",
    "data-name": "Path 510272",
    d: "M618.983,345.563q-.257-2.46-.639-4.9a98.159,98.159,0,0,0-2.009-9.69,38.5,38.5,0,0,0-1.431-4.421,6.523,6.523,0,0,0,.036-.8v-.952c0-.635-.04-1.266-.092-1.9a23.15,23.15,0,0,0-.607-3.714c-.181-.707-.4-1.4-.6-2.1a.024.024,0,0,0-.044,0,27.7,27.7,0,0,1,.731,3.705,34.9,34.9,0,0,1,.33,3.717c0,.338.02.679.02,1.021v.438a31.387,31.387,0,0,0-1.668-3.456,41.837,41.837,0,0,0-3.388-5.068,2.145,2.145,0,0,0-.08-.555l-.145-.663c-.1-.45-.217-.9-.338-1.346-.245-.9-.571-1.764-.852-2.652a.024.024,0,0,0-.044,0c.261.88.434,1.788.635,2.681.1.442.2.884.293,1.326.048.221.1.442.141.663v.048q-.6-.76-1.206-1.491c-1.893-2.218-3.967-4.264-6.052-6.294-.257-.249-.518-.494-.78-.74,0,0-.052,0-.032.032,2.009,2.082,3.959,4.184,5.819,6.386q.663.8,1.3,1.608l-.675-.45c-.575-.374-1.157-.743-1.76-1.077s-1.206-.667-1.825-.973-1.314-.571-1.925-.928c-.024,0-.048.028,0,.04a14.911,14.911,0,0,1,1.8,1c.6.358,1.206.719,1.8,1.093s1.165.731,1.744,1.109c.482.314.957.655,1.455.944a46.915,46.915,0,0,1,3.171,4.614,33.8,33.8,0,0,1,1.64,3.111l-.354-.153-.908-.4c-.579-.261-1.165-.51-1.748-.768-1.113-.482-2.239-.924-3.328-1.455a15.076,15.076,0,0,1-1.78-.989c-.024,0-.044.024,0,.04a38.388,38.388,0,0,0,6.551,3.38l.977.434c.265.117.534.249.8.354a34.508,34.508,0,0,1,1.64,4.61,91.911,91.911,0,0,1,2.154,9.581c.571,3.215.952,6.487,1.25,9.758.036.4.072.8.121,1.206a.129.129,0,0,0,.257,0C619.329,348.874,619.156,347.235,618.983,345.563Z",
    transform: "translate(-597.618 -306.025)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510273",
    "data-name": "Path 510273",
    d: "M629.381,328.334c-.181-1-.446-1.989-.719-2.974a.024.024,0,1,0-.044,0c.249.969.43,1.953.611,2.934s.35,2.009.49,3.014h.028A25.692,25.692,0,0,0,629.381,328.334Z",
    transform: "translate(-614.04 -316.136)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510274",
    "data-name": "Path 510274",
    d: "M613.337,336.221a18.247,18.247,0,0,0-2.154-1.206c-.362-.189-.727-.366-1.093-.543s-.767-.334-1.141-.522c-.024,0-.048.028,0,.04.362.181.7.4,1.061.595l1.1.6a24.114,24.114,0,0,0,2.194,1.133.056.056,0,0,0,.036-.1Z",
    transform: "translate(-602.261 -321.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510275",
    "data-name": "Path 510275",
    d: "M649.53,332.1s6.261-1.5,9.135-5.695c2.745-4.019,3.617-10.851,3.7-11.454-.113.555-1.4,6.531-5.667,9.312C653.436,326.4,650.281,328.148,649.53,332.1Z",
    transform: "translate(-626.55 -309.93)",
    fill: "#263238",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510276",
    "data-name": "Path 510276",
    d: "M660.471,330.69a8,8,0,0,0-2.311,3.8h.02a9.323,9.323,0,0,1,2.319-3.774C660.507,330.7,660.507,330.67,660.471,330.69Z",
    transform: "translate(-631.711 -319.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510277",
    "data-name": "Path 510277",
    d: "M649.352,332.569s6.261-1.5,9.135-5.7c2.745-4.019,3.617-10.851,3.7-11.45a.174.174,0,0,0,0-.04s-3,4.268-6.149,5.357S648.443,325.592,649.352,332.569Z",
    transform: "translate(-626.371 -310.188)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510278",
    "data-name": "Path 510278",
    d: "M657.263,320.694A25.669,25.669,0,0,1,655.329,324a13.426,13.426,0,0,1-2.576,2.652c-.852.675-1.752,1.286-2.612,1.949v-.032c.161-.237.333-.47.51-.7.362-.458.752-.892,1.145-1.318.78-.844,1.571-1.672,2.271-2.588a9.588,9.588,0,0,0,1-1.608c0-.028-.032-.04-.044,0-1.017,2.118-3.042,3.472-4.493,5.257a8.337,8.337,0,0,0-.579.8,3.306,3.306,0,0,0-.358.639,13.086,13.086,0,0,0-2.138,2.158,8.791,8.791,0,0,1,.253-1.206,6.118,6.118,0,0,1,.663-1.587c0-.024-.024-.052-.04-.024a7.366,7.366,0,0,0-.727,1.575,5.366,5.366,0,0,0-.229,1.35h0a11.953,11.953,0,0,0-.844,1.314c.024-.133.048-.265.076-.4.125-.627.261-1.246.422-1.865a11.145,11.145,0,0,1,1.507-3.525c0-.024-.02-.052-.036-.028a13.442,13.442,0,0,0-1.672,3.452c-.2.615-.358,1.242-.5,1.869-.068.309-.129.619-.189.928-.032.161-.064.326-.092.49a22.386,22.386,0,0,0-1.443,4.244,62.124,62.124,0,0,0-1.334,7.917,66.011,66.011,0,0,0-.434,8.408c0,.35.028.7.048,1.053a.072.072,0,1,0,.145,0c.06-1.387.1-2.777.177-4.168s.2-2.773.354-4.16a73.482,73.482,0,0,1,1.306-8.094,20.914,20.914,0,0,1,2.411-6.6,12.484,12.484,0,0,1,2.259-2.689c.876-.8,1.837-1.479,2.765-2.206a15.178,15.178,0,0,0,2.536-2.44,19.877,19.877,0,0,0,2.009-3.215c.149-.281.3-.567.45-.848C657.315,320.694,657.275,320.666,657.263,320.694Z",
    transform: "translate(-622.547 -313.359)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510279",
    "data-name": "Path 510279",
    d: "M673.925,322.982a20.891,20.891,0,0,1-1.395,2.44l.028.02A16.991,16.991,0,0,0,673.969,323C674,322.982,673.953,322.954,673.925,322.982Z",
    transform: "translate(-640.306 -314.727)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510280",
    "data-name": "Path 510280",
    d: "M592.35,351.26s-.1,8.9,5.225,11.466,8.174.43,11.792,1.29h0a13.03,13.03,0,0,0-6.832-4.943C598.31,358.016,593.632,354.965,592.35,351.26Z",
    transform: "translate(-592.35 -331.648)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510281",
    "data-name": "Path 510281",
    d: "M592.35,351.26s-.1,8.9,5.225,11.466,8.174.43,11.792,1.29h0a19.962,19.962,0,0,0-6.028-1.784A12.19,12.19,0,0,1,592.35,351.26Z",
    transform: "translate(-592.35 -331.648)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510282",
    "data-name": "Path 510282",
    d: "M613.2,371.762a9.005,9.005,0,0,0-2.118-1.431c-.113-.056-.229-.1-.346-.149a2.192,2.192,0,0,0-.181-.2c-.157-.165-.326-.326-.5-.474a7.185,7.185,0,0,0-1.073-.772c-.88-.518-1.845-.884-2.749-1.362-.024,0-.048.024-.02.04.446.229.876.486,1.31.739s.852.478,1.262.743a8.791,8.791,0,0,1,1.053.8c.092.08.185.169.273.261a13.915,13.915,0,0,0-1.8-.478c-.977-.2-1.961-.338-2.934-.543a14.319,14.319,0,0,1-1.411-.382c-.442-.358-.88-.711-1.3-1.093a10.8,10.8,0,0,1-1.379-1.527c0-.024-.056,0-.036.024a16.269,16.269,0,0,0,2.178,2.411c-.229-.088-.454-.181-.679-.281a10.985,10.985,0,0,1-4.533-3.774c0-.024-.056,0-.04.024a12.46,12.46,0,0,0,3.669,3.521,11.03,11.03,0,0,0,2.319,1.1,22.018,22.018,0,0,0,2.878.683,20,20,0,0,1,2.813.671,8.364,8.364,0,0,1,2.363,1.242,11.056,11.056,0,0,1,3.187,3.955,19.746,19.746,0,0,1,1.756,6.507c0,.092.161.092.153,0C617.083,378.249,616.082,374.362,613.2,371.762Z",
    transform: "translate(-595.839 -339.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510283",
    "data-name": "Path 510283",
    d: "M616.553,372.551a3.043,3.043,0,0,0-1.093-.989,4.018,4.018,0,0,1-1.3-1.077c-.02-.024-.06,0-.04.024a4.388,4.388,0,0,0,1.149,1.029,3.943,3.943,0,0,1,1.25,1.037.02.02,0,1,0,.032-.024Z",
    transform: "translate(-605.369 -343.14)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510284",
    "data-name": "Path 510284",
    d: "M627.21,399.2l.241,4.9.743,14.95h11.161l.74-14.95.245-4.9Z",
    transform: "translate(-613.2 -360.321)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510285",
    "data-name": "Path 510285",
    d: "M627.21,399.2l.241,4.9h12.644l.245-4.9Z",
    transform: "translate(-613.2 -360.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204089",
    "data-name": "Rectangle 204089",
    width: 14.693,
    height: 4.666,
    transform: "translate(27.924 41.507) rotate(180)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12",
    transform: "translate(218.038 71.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510286",
    "data-name": "Path 510286",
    d: "M561.46,139.253a87.733,87.733,0,0,1-1.515,13.291c-.723,3.376-2.476,6.028-6.117,6.462-3.38.4-8.062-.185-10.6-2.681a4.584,4.584,0,0,1-1.206-4.248c.37-2.222,3.525-14.267,4.485-18.025a70.477,70.477,0,0,1,2.142-6.78c2.034-5.566,6.908-5.04,9.364-3.943a5,5,0,0,1,2.725,3.038C562.151,130.371,561.693,135.125,561.46,139.253Z",
    transform: "translate(-510.826 -122.624)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510287",
    "data-name": "Path 510287",
    d: "M551.519,124.981c-2.954.993-3.971,3.983-4.959,6.651-1.378,3.717-2.693,7.455-3.822,11.253-.547,1.825-1.049,3.665-1.5,5.518a29.793,29.793,0,0,0-1.081,5.482c-.141,3.03,2.456,4.706,5.068,5.434a.1.1,0,0,0,.064-.2,7.88,7.88,0,0,1-3.987-2.319c-1.286-1.608-.9-3.472-.523-5.329.651-3.159,1.483-6.278,2.411-9.364s2.009-6.141,3.095-9.179c1.049-2.89,2.009-6.74,5.225-7.905C551.564,124.981,551.552,124.948,551.519,124.981Z",
    transform: "translate(-509.763 -124.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510288",
    "data-name": "Path 510288",
    d: "M584.658,131.877c-.273-2.355-1.206-4.726-3.557-5.667h0c3.01,1.346,3.388,4.847,3.48,7.744.1,3.054.08,6.1-.044,9.155-.117,2.934-.3,5.888-.687,8.8a14.864,14.864,0,0,1-3.472,8.416c-.044.048.02.121.068.076,2.07-1.893,3-4.718,3.456-7.411a81.422,81.422,0,0,0,.9-10.787A71.4,71.4,0,0,0,584.658,131.877Z",
    transform: "translate(-533.811 -124.769)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510289",
    "data-name": "Path 510289",
    d: "M572.877,384.208s-.04,16.952-.04,16.96c-.1,3.131-.237,5.876-.442,7.286a.052.052,0,0,1,0,.024,2.145,2.145,0,0,1-.261.961v.02c-.953.6-25.994.559-26.871.265s-.1-2.813.876-3.581,10.57-5.048,10.57-5.048l.2-16.936Z",
    transform: "translate(-512.589 -279.051)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510290",
    "data-name": "Path 510290",
    d: "M572.957,417.935s-.121,3.352-.121,3.36c-.1,3.131-.237,5.876-.442,7.286a.052.052,0,0,1,0,.024,4.331,4.331,0,0,1-.261.961v.02c-.953.6-25.994.559-26.871.265s-.1-2.813.876-3.581,10.57-5.048,10.57-5.048l.076-3.412Z",
    transform: "translate(-512.589 -299.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510291",
    "data-name": "Path 510291",
    d: "M570.3,426.123a5.873,5.873,0,0,1,4.9,1.37c.048.048,0,.113-.072.092a23.533,23.533,0,0,0-4.823-1.254.1.1,0,1,1,0-.209Z",
    transform: "translate(-527.729 -304.11)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510292",
    "data-name": "Path 510292",
    d: "M567.228,427.773a5.882,5.882,0,0,1,4.9,1.37c.044.048-.024.113-.076.092a23.532,23.532,0,0,0-4.823-1.254.1.1,0,1,1,0-.209Z",
    transform: "translate(-525.893 -305.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510293",
    "data-name": "Path 510293",
    d: "M564.157,429.423a5.878,5.878,0,0,1,4.9,1.37c.044.048-.024.113-.076.092a23.465,23.465,0,0,0-4.823-1.254.1.1,0,0,1,0-.209Z",
    transform: "translate(-524.057 -306.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510294",
    "data-name": "Path 510294",
    d: "M545.223,434.522c.876.3,25.918.338,26.871-.265.366-.225.583-3.874.723-8.291v-.137l-16.152-.209v.277s-9.585,4.268-10.55,5.044S544.351,434.212,545.223,434.522Z",
    transform: "translate(-512.569 -303.848)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510295",
    "data-name": "Path 510295",
    d: "M572.821,425.831v.145c-.141,4.421-.358,8.062-.723,8.287-.434.273-5.864.4-11.731.462-7.021.052-14.661-.036-15.139-.2-.872-.293-.092-2.813.876-3.581s10.57-5.048,10.57-5.048v-.269l5.385.068Z",
    transform: "translate(-512.569 -303.854)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510296",
    "data-name": "Path 510296",
    d: "M546.391,445.265c4.224-.1,21.256-.084,25.436.141.036,0,.036.024,0,.024-4.18.189-21.216.04-25.436-.092C546.3,445.333,546.3,445.269,546.391,445.265Z",
    transform: "translate(-513.452 -315.564)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510297",
    "data-name": "Path 510297",
    d: "M562.044,425.7c-.47,2.693-1.182,6.663-1.688,9.026-7.021.052-14.661-.036-15.139-.2-.872-.293-.092-2.813.876-3.581s10.57-5.048,10.57-5.048v-.269Z",
    transform: "translate(-512.563 -303.854)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510298",
    "data-name": "Path 510298",
    d: "M590.97,298.532l-18.113-.326s-.141-31.255.052-41.093c.221-11.229,1.788-44.9,1.788-44.9l13.536.374s2.693,7.885,2.411,12.736c-.08,1.4-1.021,3.44-1.435,4.931L587.043,258.1Z",
    transform: "translate(-529.291 -176.206)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510299",
    "data-name": "Path 510299",
    d: "M591.089,418.18a13.323,13.323,0,0,0-1.439-.153c-.534-.052-1.069-.108-1.608-.145-1.029-.072-2.058-.121-3.091-.153-2.078-.064-4.156-.1-6.237-.1q-1.778,0-3.549.056a.036.036,0,1,0,0,.072c2.058.133,4.119.221,6.181.318s4.119.2,6.181.213H589.3a14.4,14.4,0,0,0,1.772-.04C591.113,418.261,591.129,418.2,591.089,418.18Z",
    transform: "translate(-530.681 -299.069)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510300",
    "data-name": "Path 510300",
    d: "M576.758,284.4c-.076-4.883-.064-10.927-.064-15.81q0-14.641.6-29.282c.217-5.474.518-10.944.832-16.409a.048.048,0,1,0-.1,0c-.8,9.782-1.258,19.592-1.539,29.406s-.382,20.689-.169,30.451c.121,5.478.265,11.542.627,17.012a.04.04,0,0,0,.076,0C576.927,294.849,576.834,289.347,576.758,284.4Z",
    transform: "translate(-531.324 -182.57)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510301",
    "data-name": "Path 510301",
    d: "M523.755,385.438s-.591,16.369-.591,16.381c-.1,3.131-.237,5.872-.442,7.286a.052.052,0,0,1,0,.024,2.121,2.121,0,0,1-.261.957.039.039,0,0,1,0,.02c-.953.6-25.994.563-26.867.265s-.1-2.813.872-3.581,10.574-5.044,10.574-5.044l.743-16.357Z",
    transform: "translate(-482.882 -279.786)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510302",
    "data-name": "Path 510302",
    d: "M523.285,417.725s-.121,3.348-.121,3.36c-.1,3.131-.237,5.872-.442,7.286a.052.052,0,0,1,0,.024,4.015,4.015,0,0,1-.261.957.04.04,0,0,1,0,.02c-.953.6-25.994.563-26.867.265s-.1-2.813.872-3.581,10.574-5.044,10.574-5.044l.076-3.412Z",
    transform: "translate(-482.882 -299.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510303",
    "data-name": "Path 510303",
    d: "M520.618,425.9a5.892,5.892,0,0,1,4.9,1.366c.044.048-.024.117-.076.1a23.533,23.533,0,0,0-4.823-1.254.1.1,0,1,1,0-.209Z",
    transform: "translate(-498.015 -303.978)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510304",
    "data-name": "Path 510304",
    d: "M517.547,427.563a5.889,5.889,0,0,1,4.9,1.366c.044.048-.024.117-.076.1a23.46,23.46,0,0,0-4.823-1.254.1.1,0,1,1,0-.209Z",
    transform: "translate(-496.179 -304.971)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510305",
    "data-name": "Path 510305",
    d: "M514.484,429.213a5.884,5.884,0,0,1,4.9,1.366c.048.048-.024.117-.076.1a23.493,23.493,0,0,0-4.823-1.254.1.1,0,1,1,0-.209Z",
    transform: "translate(-494.346 -305.958)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510306",
    "data-name": "Path 510306",
    d: "M495.536,434.308c.872.3,25.914.338,26.866-.265.366-.221.587-3.87.723-8.287v-.137l-16.156-.209v.273s-9.589,4.272-10.57,5.048S494.66,434.019,495.536,434.308Z",
    transform: "translate(-482.845 -303.723)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510307",
    "data-name": "Path 510307",
    d: "M496.716,445.053c4.22-.1,21.252-.088,25.436.137.032,0,.032.024,0,.028-4.184.185-21.216.04-25.44-.1C496.624,445.117,496.624,445.053,496.716,445.053Z",
    transform: "translate(-483.739 -315.436)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510308",
    "data-name": "Path 510308",
    d: "M550.514,229.451s-8.074,23.209-8.327,27.509c-.217,3.665-.8,41.323-.8,41.323l-17.683-.4s2.813-38.9,3.215-42.713c.631-6.028,3.878-19.665,8.178-34.418.8-2.761,3.416-8.97,3.416-8.97l19.922.551S558,221.482,553.653,228C553.649,227.984,551.74,228.8,550.514,229.451Z",
    transform: "translate(-499.92 -175.949)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510309",
    "data-name": "Path 510309",
    d: "M542.691,418.211c-1.981-.109-4.019-.217-6.028-.229s-3.946-.036-5.912,0c-1.117.028-2.231.032-3.348.1a.028.028,0,1,0,0,.052c1.981.161,3.971.193,5.96.233s3.939.072,5.912.048c1.113,0,2.226-.036,3.344-.076C542.743,418.347,542.811,418.215,542.691,418.211Z",
    transform: "translate(-502.111 -299.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510310",
    "data-name": "Path 510310",
    d: "M542.2,239.157c-.732,2.218-1.362,4.473-2.01,6.712s-1.334,4.517-2.009,6.78c-1.282,4.373-3.243,11.707-4.236,16.156s-3.842,39.755-3.838,40.338a.044.044,0,1,0,.088,0c.547-4.1,3.617-38.421,4.055-40.02,1.206-4.389,2.492-10.518,3.762-14.894.723-2.5,1.455-4.987,2.174-7.487s1.5-5.016,2.146-7.552a.068.068,0,0,0-.133-.032Z",
    transform: "translate(-503.754 -192.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510311",
    "data-name": "Path 510311",
    d: "M578.63,252.206a17.108,17.108,0,0,0,2.789.3c.948,0,1.861-.125,2.813-.209a20.729,20.729,0,0,1,2.689.088,9.243,9.243,0,0,0,2.7-.253.032.032,0,1,1,0,.064,16.122,16.122,0,0,1-2.656.575c-.928.1-1.849-.04-2.781,0a22.605,22.605,0,0,1-2.857.084,10.047,10.047,0,0,1-2.725-.587C578.573,252.255,578.6,252.2,578.63,252.206Z",
    transform: "translate(-532.75 -200.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510312",
    "data-name": "Path 510312",
    d: "M573.744,273.22c.209-.711.4-1.431.627-2.142.446-1.439.9-2.878,1.391-4.3.977-2.833,1.9-5.683,2.93-8.5.579-1.608,1.109-3.215,1.78-4.779a.034.034,0,1,1,.064.02c-.358,1.463-.844,2.894-1.286,4.336s-.912,2.874-1.383,4.308c-.936,2.845-1.853,5.7-2.87,8.52q-.4,1.206-.88,2.363c-.309.8-.563,1.628-.932,2.411a.036.036,0,1,1-.068-.024C573.27,274.679,573.527,273.955,573.744,273.22Z",
    transform: "translate(-529.475 -200.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510313",
    "data-name": "Path 510313",
    d: "M574.14,229.771c.129-1.23.543-5.12.611-5.831a11.794,11.794,0,0,0,.04-2.444,17.954,17.954,0,0,0-2.23-.04c-.727,0-1.455-.04-2.178-.076-1.471-.08-2.942-.225-4.4-.4a.154.154,0,1,0-.04.305q2.211.326,4.445.482c.723.052,3.533.2,4.184.125,0,.293-.2,1.374-.225,1.608a8.928,8.928,0,0,0-.928.06q-.518.036-1.037.048c-.715,0-1.435,0-2.15-.024a33.173,33.173,0,0,1-4.135-.442.032.032,0,1,0,0,.06,24.113,24.113,0,0,0,4.22.583q1,.048,2.009,0c.362,0,.723-.032,1.085-.056a7.185,7.185,0,0,0,.932-.1v.141c-.088.679-.539,4.678-.691,6-.74.338-4.349,2.009-4.77,1.764-.8-.434-3.565-2.283-4.373-2.737.113-1.186.265-2.363.466-3.537.1-.6.217-1.206.346-1.8a11.625,11.625,0,0,0,.338-1.845c0-.052-.076-.1-.113-.044l-.056.072a.036.036,0,0,0,0,.04,8.369,8.369,0,0,0-.518,1.632c-.157.611-.293,1.206-.4,1.841q-.374,1.853-.579,3.726a.233.233,0,0,0,.1.217c1.206.711,4.541,2.853,4.847,2.91.587.109,4.987-1.8,5.1-1.877S574.124,229.924,574.14,229.771Z",
    transform: "translate(-524.016 -181.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510314",
    "data-name": "Path 510314",
    d: "M601.159,229.935c-.1-1.057-.4-4.421-.466-5.016a14.7,14.7,0,0,1-.072-2.09,7.2,7.2,0,0,1,1.27.108c.4.032.832.056,1.246.068a20.732,20.732,0,0,0,2.5-.084c.125,0,.153.253.028.265a22.986,22.986,0,0,1-2.524.137,17.862,17.862,0,0,1-2.387-.157c0,.253.141,1.206.161,1.4a3.611,3.611,0,0,1,.534.109c.2.04.4.076.591.1a11.489,11.489,0,0,0,1.226.117,12.74,12.74,0,0,0,2.351-.121c.024,0,.028.044,0,.052a9.046,9.046,0,0,1-2.411.233,9.972,9.972,0,0,1-1.141-.113c-.209-.036-.4-.072-.619-.121a2.5,2.5,0,0,1-.534-.141v.125c.064.587.4,4.019.514,5.16.426.338,2.52,1.977,2.757,1.809.45-.326,1.989-1.728,2.44-2.066-.088-1.017-.2-2.034-.338-3.046-.072-.522-.149-1.041-.233-1.563a15.39,15.39,0,0,1-.229-1.608c0-.044.04-.076.064-.028l.032.064a.056.056,0,0,1,0,.036,10.443,10.443,0,0,1,.33,1.423c.1.53.193,1.065.277,1.608q.249,1.608.4,3.215a.229.229,0,0,1-.052.181c-.651.539-2.5,2.146-2.681,2.186a16.4,16.4,0,0,1-2.95-1.925A.5.5,0,0,1,601.159,229.935Z",
    transform: "translate(-545.911 -182.558)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510315",
    "data-name": "Path 510315",
    d: "M596.528,221.542c-.028-1.833-.072-3.669-.189-5.5-.068-1.053-.145-2.11-.249-3.163,0-.036-.06-.04-.06,0,.088,1.849.173,3.7.241,5.546s.068,3.669.088,5.506c0,1.057,0,2.11.024,3.167a.032.032,0,1,0,.06,0C596.544,225.248,596.56,223.395,596.528,221.542Z",
    transform: "translate(-543.181 -176.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510316",
    "data-name": "Path 510316",
    d: "M479.01,187.236,466.1,188.26a22.615,22.615,0,0,1-.535-3.215c-.257-3.251-1.033-13.009-1.033-13.009l16.245-1.286,1.045,13.178C481.924,185.25,479.01,187.236,479.01,187.236Z",
    transform: "translate(-464.53 -151.409)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510317",
    "data-name": "Path 510317",
    d: "M503.353,203.506c.1,1.282-2.628,3.183-2.813,3.3.446-.358.165-2.894.165-2.894A16.18,16.18,0,0,1,503.353,203.506Z",
    transform: "translate(-486.068 -170.986)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510318",
    "data-name": "Path 510318",
    d: "M471.24,181.648c1.9-.309,3.8-.494,5.715-.655s3.822-.261,5.743-.253c-1.9.309-3.8.5-5.711.655S473.153,181.668,471.24,181.648Z",
    transform: "translate(-468.543 -157.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510319",
    "data-name": "Path 510319",
    d: "M471.66,187.3c1.491-.277,2.99-.43,4.493-.559a44.644,44.644,0,0,1,4.525-.157,44.678,44.678,0,0,1-4.493.567C474.682,187.253,473.175,187.333,471.66,187.3Z",
    transform: "translate(-468.794 -160.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510320",
    "data-name": "Path 510320",
    d: "M472.08,192.632a50.85,50.85,0,0,1,9.018-.715c-1.491.277-2.99.43-4.493.559A41.426,41.426,0,0,1,472.08,192.632Z",
    transform: "translate(-469.046 -164.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510321",
    "data-name": "Path 510321",
    d: "M577.66,151.019c0,.4-1.1,3.3-2.813,3.685-.563.125-1.379-2.91-1.379-2.91l-.113-.213-1.555-2.946,3.038-3.368.446-.458s.374.836.828,1.877c.024.048.044.1.064.149a1.556,1.556,0,0,1,.076.169c.072.153.141.313.209.474s.1.237.153.366l.153.382A21.519,21.519,0,0,1,577.66,151.019Z",
    transform: "translate(-528.689 -135.894)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510322",
    "data-name": "Path 510322",
    d: "M576.082,146.687a6.671,6.671,0,0,1-2.757,4.9l-1.555-2.946,3.038-3.368.446-.458S575.628,145.646,576.082,146.687Z",
    transform: "translate(-528.671 -135.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510323",
    "data-name": "Path 510323",
    d: "M556.768,132c-.084,6.028,3.529,6.752,4.823,6.764,1.206,0,5.225-.1,5.92-6.093s-2.078-7.929-4.783-8.1S556.86,125.967,556.768,132Z",
    transform: "translate(-519.697 -123.782)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510324",
    "data-name": "Path 510324",
    d: "M557.874,140.616a3.566,3.566,0,0,0,.4-.109.7.7,0,0,0,.4-.189.217.217,0,0,0,0-.261.534.534,0,0,0-.534-.1.8.8,0,0,0-.474.305.229.229,0,0,0,.205.35Z",
    transform: "translate(-520.216 -132.973)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510325",
    "data-name": "Path 510325",
    d: "M566.989,139.735a3.543,3.543,0,0,1-.4-.06.663.663,0,0,1-.4-.145.217.217,0,0,1,0-.261.531.531,0,0,1,.518-.153.8.8,0,0,1,.506.245.229.229,0,0,1-.221.374Z",
    transform: "translate(-525.305 -132.478)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510326",
    "data-name": "Path 510326",
    d: "M566.163,143.7a.031.031,0,0,1,.032.032c0,.4.072.884.446,1v.024C566.183,144.713,566.082,144.086,566.163,143.7Z",
    transform: "translate(-525.302 -135.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510327",
    "data-name": "Path 510327",
    d: "M566.531,142.6c.659-.076.755,1.246.145,1.314S565.976,142.656,566.531,142.6Z",
    transform: "translate(-525.317 -134.567)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510328",
    "data-name": "Path 510328",
    d: "M567.644,142.582a.892.892,0,0,0,.4.193c.161,0,.277-.145.374-.285h.024c.02.253-.06.518-.33.579s-.438-.161-.522-.4C567.56,142.631,567.6,142.558,567.644,142.582Z",
    transform: "translate(-526.165 -134.506)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510329",
    "data-name": "Path 510329",
    d: "M559.952,143.63s-.032.024-.028.04c.044.4.028.884-.334,1.049v.024C560.044,144.643,560.06,144.012,559.952,143.63Z",
    transform: "translate(-521.386 -135.188)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510330",
    "data-name": "Path 510330",
    d: "M558.779,142.65c-.663,0-.611,1.326,0,1.322S559.337,142.646,558.779,142.65Z",
    transform: "translate(-520.615 -134.602)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510331",
    "data-name": "Path 510331",
    d: "M557.763,142.836c-.1.076-.2.209-.326.221s-.257-.121-.358-.257h-.02c0,.253.1.514.346.551s.378-.189.43-.442C557.84,142.88,557.8,142.808,557.763,142.836Z",
    transform: "translate(-519.873 -134.691)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510332",
    "data-name": "Path 510332",
    d: "M565.695,152.286c-.084.108-.169.249-.313.281a1.077,1.077,0,0,1-.45-.052s-.028,0,0,.024a.547.547,0,0,0,.542.161.442.442,0,0,0,.281-.4C565.755,152.274,565.711,152.27,565.695,152.286Z",
    transform: "translate(-524.573 -140.359)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510333",
    "data-name": "Path 510333",
    d: "M561.325,142.941s-.048.619-.032.908c0,.024.072.036.173.032h0a1.378,1.378,0,0,0,1.3-.595c0-.028-.02-.056-.044-.036a2.106,2.106,0,0,1-1.234.438c-.024-.08.117-1.057.072-1.057a2.607,2.607,0,0,0-.651.189c.064-1.286.33-2.556.374-3.842a.04.04,0,0,0-.076,0,20.9,20.9,0,0,0-.579,4.119C560.63,143.255,561.213,142.99,561.325,142.941Z",
    transform: "translate(-522.008 -132.389)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510334",
    "data-name": "Path 510334",
    d: "M562.76,150.246a1.656,1.656,0,0,0,.671.514.727.727,0,0,0,.454.028c.33-.088.338-.4.277-.647a1.677,1.677,0,0,0-.149-.4A2.15,2.15,0,0,1,562.76,150.246Z",
    transform: "translate(-523.282 -138.842)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510335",
    "data-name": "Path 510335",
    d: "M564.43,151.309a.728.728,0,0,0,.454.028c.33-.088.338-.4.277-.647A.772.772,0,0,0,564.43,151.309Z",
    transform: "translate(-524.281 -139.411)",
    fill: "#ff9abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510336",
    "data-name": "Path 510336",
    d: "M567.562,132.273a2.484,2.484,0,0,1-1.66-1.821,6.552,6.552,0,0,1-2.922-1.752c.06.121.47.973.7,1.4a6.729,6.729,0,0,1-5.486-2.93,6.663,6.663,0,0,0-1.334,2.636,7.226,7.226,0,0,1,.647-4.055,3.818,3.818,0,0,1,3.267-2.03,5.446,5.446,0,0,1,5.482.892C569.093,126.96,567.562,132.273,567.562,132.273Z",
    transform: "translate(-519.716 -123.055)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510337",
    "data-name": "Path 510337",
    d: "M562.443,134.686a7.117,7.117,0,0,0,2.054.446h0a6.061,6.061,0,0,1-3.026-1.3,5.655,5.655,0,0,1-.977-1.033,3.87,3.87,0,0,1-.7-1.378.032.032,0,0,0-.06,0,4.644,4.644,0,0,0,.506,1.455,4.188,4.188,0,0,0,1.017,1.141,4.884,4.884,0,0,0,1.206.667",
    transform: "translate(-521.47 -127.872)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510338",
    "data-name": "Path 510338",
    d: "M580.8,143.445s1.177-1.977,2.066-1.575.1,3.215-.876,3.649a1.021,1.021,0,0,1-1.407-.442Z",
    transform: "translate(-533.94 -134.103)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510339",
    "data-name": "Path 510339",
    d: "M583.457,143.93s.02,0,0,.028a2.588,2.588,0,0,0-1.206,1.708.571.571,0,0,1,.832-.217v.04a.631.631,0,0,0-.675.269,3.031,3.031,0,0,0-.289.583c-.028.064-.145.04-.125-.036h0A2.252,2.252,0,0,1,583.457,143.93Z",
    transform: "translate(-534.78 -135.367)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510340",
    "data-name": "Path 510340",
    d: "M559.614,178.889l.88-5.446a7.326,7.326,0,0,1-1.5-4.176v-.052a1.95,1.95,0,0,1,0-.217c.048-3.1,4.622-8.5,5.454-9.581a10.09,10.09,0,0,1,1-1.113c.141-.129.281-.257.426-.37a4.32,4.32,0,0,1,6.089.084c.145.125.285.265.426.4.044.04.084.084.125.129a18.371,18.371,0,0,1,3.034,5.036q.084.181.157.362c.366.852.7,1.736,1.021,2.636h0c.036.1.072.2.1.3h0a87.342,87.342,0,0,1,3.147,12.515Z",
    transform: "translate(-521.029 -143.018)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510341",
    "data-name": "Path 510341",
    d: "M564.164,162.4a.305.305,0,1,1-.182-.287A.305.305,0,0,1,564.164,162.4Zm3.018-.237a.3.3,0,0,0-.305.293.3.3,0,1,0,.305-.293Zm3.316.068a.3.3,0,1,0,.3.305A.305.305,0,0,0,570.5,162.227Zm3.316.068a.3.3,0,1,0,0,.6.3.3,0,0,0,.305-.293.3.3,0,0,0-.305-.309Zm-7.953-2.741c-.145.113-.285.241-.426.37a.27.27,0,0,0,.137.04.3.3,0,0,0,.309-.3.331.331,0,0,0-.02-.113Zm3.038-.125a.3.3,0,1,0,.3.305A.305.305,0,0,0,568.9,159.43Zm3.05.209a.322.322,0,0,0-.044.153.3.3,0,0,0,.3.309.285.285,0,0,0,.173-.052,3.431,3.431,0,0,0-.426-.39Zm-11.514,8a.3.3,0,1,0,.3.305A.3.3,0,0,0,560.434,167.637Zm3.316.068a.128.128,0,1,0,0-.008Zm3.316.068a.284.284,0,1,0,.3.3A.305.305,0,0,0,567.065,167.773Zm3.316.068a.305.305,0,1,0,0,.607.3.3,0,0,0,.305-.3.305.305,0,0,0-.305-.309Zm3.316.072a.3.3,0,1,0,.293.305.3.3,0,0,0-.293-.305Zm3.014.3a.3.3,0,0,0,0,.06.289.289,0,0,0,.113.241c-.04-.1-.076-.2-.113-.3Zm-14.561-3.308a.3.3,0,1,0,.3.3A.3.3,0,0,0,562.15,164.908Zm3.316.068a.306.306,0,0,0-.31.3.3.3,0,0,0,.3.305.3.3,0,1,0,.012-.6Zm3.316.068a.305.305,0,1,0,.27.3A.305.305,0,0,0,568.782,165.044Zm3.316.072a.3.3,0,1,0,.293.305.3.3,0,0,0-.293-.305Zm3.436.1a.293.293,0,0,0-.12-.028.3.3,0,1,0,0,.6.289.289,0,0,0,.293-.213Q575.618,165.394,575.533,165.213Zm-15.216,8.038a.305.305,0,1,0,.3.309.305.305,0,0,0-.3-.309Zm3.316.072a.3.3,0,1,0,.3.305.306.306,0,0,0-.3-.305Zm3.316.068a.3.3,0,0,0,0,.6.3.3,0,0,0,.305-.293.3.3,0,0,0-.305-.309Zm3.316.068a.3.3,0,1,1-.016,0Zm3.316.068a.3.3,0,1,0,.31.309.3.3,0,0,0-.31-.309Zm3.312.072a.3.3,0,1,0,.3.305A.3.3,0,0,0,576.892,173.6ZM559,170.619a1.95,1.95,0,0,0,0,.217v.052a.262.262,0,0,0,.032-.125A.3.3,0,0,0,559,170.619Zm3.054-.092a.3.3,0,1,0,.3.3A.3.3,0,0,0,562.05,170.526Zm3.316.068a.3.3,0,1,0,0,.6.3.3,0,0,0,.305-.293.3.3,0,0,0-.321-.309Zm3.316.068a.3.3,0,1,1-.016,0Zm3.316.068a.3.3,0,1,0,.31.309.3.3,0,0,0-.326-.309Zm3.312.068a.305.305,0,0,0-.305.3.3.3,0,1,0,.6,0,.305.305,0,0,0-.313-.3Zm-15.107,8.07a.284.284,0,1,0,.3.3A.305.305,0,0,0,560.2,178.869Zm3.316.068a.305.305,0,1,0,.293.309.3.3,0,0,0-.293-.3Zm3.316.072a.3.3,0,1,0,.293.305.3.3,0,0,0-.293-.305Zm3.316.068a.3.3,0,1,0,.293.305A.3.3,0,0,0,570.148,179.078Zm3.312.068a.3.3,0,1,0,.3.309.3.3,0,0,0-.3-.309Zm3.316.068a.3.3,0,1,0,.213.093.3.3,0,0,0-.213-.093Zm-14.87-3.074a.3.3,0,1,0,.305.309.3.3,0,0,0-.293-.313Zm3.316.068a.305.305,0,0,0-.309.3.3.3,0,1,0,.309-.3Zm3.312.072a.292.292,0,1,0,.012,0Zm3.316.068a.295.295,0,1,0,.008,0Zm3.316.068a.292.292,0,1,0,.012,0Zm3.316.068a.292.292,0,1,0,.012,0Z",
    transform: "translate(-521.029 -144.638)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510342",
    "data-name": "Path 510342",
    d: "M539.908,163.808c-1.475,3.537-8.44,15.3-12.057,15.726-5.687.671-12-1.849-15.549-2.6-1.129-.237,1.374-10.108,3.484-9.4a43.15,43.15,0,0,0,9.682,1.837c1.033-.052,6.832-5.2,10.911-8.745C539.763,157.663,541.773,159.327,539.908,163.808Z",
    transform: "translate(-492.935 -144.463)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510343",
    "data-name": "Path 510343",
    d: "M504.173,175.508l-1.608-1.125a6.51,6.51,0,0,1-1.334-1.338,12.386,12.386,0,0,0-13.134-3.287c-2.5.832-3.014,2.954-.257,2.548a26.709,26.709,0,0,1,3.922-.563s-2.054,2.19-1.708,3.894a32.058,32.058,0,0,0,1.226,4.393,6.9,6.9,0,0,0,.84-.157,3.665,3.665,0,0,0,2.934,2.572l2.91.627Z",
    transform: "translate(-477.363 -150.407)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510344",
    "data-name": "Path 510344",
    d: "M499.685,174.557a19.243,19.243,0,0,0-6.278-.133c-2.572.5-7.391,2.166-7,4.059.289,1.391,2.182.916,2.182.916s-1.845,1.105-1.314,2.3c.486,1.093,1.933.639,1.933.639a1.414,1.414,0,0,0-.334,1.825c.8,1.157,2.777-.844,4.61-.378C493.894,183.893,499.685,174.557,499.685,174.557Z",
    transform: "translate(-477.601 -153.479)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510345",
    "data-name": "Path 510345",
    d: "M497.657,181.28a10.449,10.449,0,0,0-5.787,2.295c-.04.036-.032.084,0,.06a25.746,25.746,0,0,1,5.783-2.331Z",
    transform: "translate(-480.866 -157.707)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510346",
    "data-name": "Path 510346",
    d: "M498.966,187.77a11.653,11.653,0,0,0-5.626,2.636c-.04.04-.032.088,0,.06a27.732,27.732,0,0,1,5.626-2.673S498.982,187.77,498.966,187.77Z",
    transform: "translate(-481.745 -161.588)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510347",
    "data-name": "Path 510347",
    d: "M551.47,167.347l5.627,8.359a114.438,114.438,0,0,0,6.76-12.057c2.082-4.762,0-6.47-4.055-3.685A61.029,61.029,0,0,0,551.47,167.347Z",
    transform: "translate(-516.529 -144.155)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510348",
    "data-name": "Path 510348",
    d: "M560.921,162.5a.305.305,0,1,1-.182-.287A.305.305,0,0,1,560.921,162.5Zm3.018-.237a.3.3,0,0,0-.305.293.3.3,0,1,0,.305-.293Zm-1.334-2.628c-.173.08-.35.173-.535.273a.3.3,0,0,0,.567-.137.265.265,0,0,0-.032-.137Zm2.857-.028h0a.294.294,0,0,0-.113.221.3.3,0,0,0,.3.309.265.265,0,0,0,.137-.032A1.494,1.494,0,0,0,565.462,159.61Zm-11.582,8.066a.3.3,0,1,0,.293.305.3.3,0,0,0-.293-.305Zm3.312.068a.3.3,0,1,0,.3.305.3.3,0,0,0-.3-.305Zm3.316.068a.127.127,0,1,0,0-.008Zm-4.823-2.841-.4.378a.3.3,0,0,0,.587-.1.3.3,0,0,0-.165-.261Zm3.215.044a.3.3,0,1,0,.3.3A.3.3,0,0,0,558.9,165.015Zm3.316.068a.305.305,0,0,0-.31.3.3.3,0,0,0,.3.305.3.3,0,0,0,.02-.6Zm-5.148,8.275a.295.295,0,1,0,.008,0Zm-1.608-2.813a9.968,9.968,0,1,0,.016.016Zm3.316.072a.3.3,0,1,0,.3.3A.3.3,0,0,0,558.775,170.618Z",
    transform: "translate(-517.786 -144.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510349",
    "data-name": "Path 510349",
    d: "M556.211,177.988a9.925,9.925,0,0,0,.627.8c.2.253.4.555.6.836q.579.8,1.161,1.608c.8,1.093,1.608,2.166,2.331,3.308,0,.02,0,.044-.028.028a32.294,32.294,0,0,1-2.484-3.159q-.591-.828-1.157-1.668c-.189-.285-.382-.575-.559-.868s-.338-.615-.53-.9C556.158,177.988,556.2,177.988,556.211,177.988Z",
    transform: "translate(-519.341 -155.733)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510350",
    "data-name": "Path 510350",
    d: "M570.727,174.77c-.426.924-.888,1.833-1.362,2.733s-.969,1.792-1.455,2.689-1.021,1.764-1.543,2.64-1.073,1.732-1.676,2.556l-.04.056-.036-.056c-.173-.281-.346-.563-.514-.848.2.265.4.53.591.8h-.076q.8-1.3,1.535-2.636l1.511-2.648c.51-.88,1-1.772,1.519-2.648S570.2,175.642,570.727,174.77Z",
    transform: "translate(-524.084 -153.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510351",
    "data-name": "Path 510351",
    d: "M579.064,176.86a1.829,1.829,0,0,1-.374.623,3.1,3.1,0,0,1-.257.257,2.614,2.614,0,0,1-.293.213A13.167,13.167,0,0,0,579.064,176.86Z",
    transform: "translate(-532.481 -155.063)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12",
    transform: "translate(67.629 121.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510352",
    "data-name": "Path 510352",
    d: "M90.989,419.127c-.169.936,2.508,1.491,3.7,1a25.617,25.617,0,0,0,2.813-1.865c2.958-2.114,7.073-5.225,7.073-5.225l13.986.844,7.8-14.384s-12.861-.743-13.745-1.206l-.161-.088c-4.019-2.046-7.363-3.617-7.744-3.416C103.684,395.359,91.145,418.17,90.989,419.127Z",
    transform: "translate(-90.699 -335.451)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510353",
    "data-name": "Path 510353",
    d: "M115.064,398.67l-7.355,14.553-3.143-.189s-4.115,3.115-7.077,5.225a25.955,25.955,0,0,1-2.813,1.865c-1.206.5-3.866-.06-3.7-1s12.712-23.768,13.737-24.335c.4-.213,3.726,1.37,7.744,3.42.056.024.109.056.161.08A12.926,12.926,0,0,0,115.064,398.67Z",
    transform: "translate(-90.693 -335.454)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510354",
    "data-name": "Path 510354",
    d: "M90.287,418.966c.173-.961,12.969-24.182,14.018-24.757.4-.225,3.886,1.443,8.038,3.581l.129.068-8.09,15.071-.249-.145s-8.874,6.7-10.1,7.206S90.106,419.927,90.287,418.966Z",
    transform: "translate(-90.279 -335.106)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510355",
    "data-name": "Path 510355",
    d: "M90.287,418.966c.173-.961,12.969-24.182,14.018-24.757.4-.225,3.886,1.443,8.038,3.581l.129.068-8.09,15.071-.249-.145s-8.874,6.7-10.1,7.206S90.106,419.927,90.287,418.966Z",
    transform: "translate(-90.279 -335.106)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510356",
    "data-name": "Path 510356",
    d: "M92.781,421.2c2.251-3.858,10.976-19.649,12.909-23.635,0-.032,0-.044-.024,0-2.315,3.778-10.911,19.636-12.949,23.615C92.673,421.255,92.733,421.287,92.781,421.2Z",
    transform: "translate(-91.728 -337.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510357",
    "data-name": "Path 510357",
    d: "M122.684,437.143a6.234,6.234,0,0,0,1.491-5.176c0-.068-.117-.044-.129,0a24.451,24.451,0,0,1-1.555,5.048.116.116,0,0,0,.193.129Z",
    transform: "translate(-109.533 -357.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510358",
    "data-name": "Path 510358",
    d: "M119.5,438.993a6.218,6.218,0,0,0,1.487-5.176c0-.068-.113-.044-.125,0a24.778,24.778,0,0,1-1.555,5.048.116.116,0,1,0,.193.129Z",
    transform: "translate(-107.631 -358.782)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510359",
    "data-name": "Path 510359",
    d: "M116.314,440.839a6.236,6.236,0,0,0,1.487-5.18c0-.068-.113-.04-.125,0a25.066,25.066,0,0,1-1.555,5.052.116.116,0,1,0,.193.129Z",
    transform: "translate(-105.723 -359.884)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510360",
    "data-name": "Path 510360",
    d: "M125.826,444.443c1.17-.145,1.415-1.479,1.23-2.411a9.38,9.38,0,0,0-2.222-4.316.048.048,0,0,0-.076,0,.221.221,0,0,0-.326.137,15.2,15.2,0,0,0-.4,4.7C124.158,443.438,124.725,444.584,125.826,444.443Zm-1.266-4.2c.092-.756.225-1.5.293-2.263.43.844.9,1.664,1.242,2.548a9.873,9.873,0,0,1,.43,1.3c.165.687.052,2.994-1.487,1.788-.852-.663-.591-2.476-.478-3.376Z",
    transform: "translate(-110.417 -361.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510361",
    "data-name": "Path 510361",
    d: "M128.174,427.575a15.874,15.874,0,0,0-2.894,3.726.217.217,0,0,0,.149.318c0,.032,0,.06.048.056a9.34,9.34,0,0,0,4.57-1.648c.776-.563,1.5-1.7.747-2.608S128.9,427.008,128.174,427.575Zm1.483-.088c1.945.169.458,1.929-.129,2.323a10.621,10.621,0,0,1-1.206.659c-.856.4-1.756.7-2.644,1.021.466-.6.88-1.238,1.326-1.857C127.535,428.9,128.58,427.39,129.657,427.486Z",
    transform: "translate(-111.197 -354.682)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510362",
    "data-name": "Path 510362",
    d: "M166.878,351.144a77.877,77.877,0,0,1,.438,7.793s20.5,9.477,21.3,18.487c.293,3.187-.133,9.163-6.386,11.888-6.989,3.042-45.611.948-45.611.948l4.823-17.784h17.036s-12.021,1.913-13.327-6.1c-1.206-7.447,3.36-15.24,3.36-15.24Z",
    transform: "translate(-117.996 -309.358)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510363",
    "data-name": "Path 510363",
    d: "M146.576,423.117c.426-2.046.84-4.107,1.314-6.145s.981-4.075,1.519-6.1c.153-.575.309-1.141.462-1.712.076-.273.149-.547.229-.8a8.367,8.367,0,0,1,.249-.8c0-.028.044,0,.04,0a13.071,13.071,0,0,1-.305,1.571c-.109.494-.209.993-.318,1.487-.225,1.017-.45,2.03-.683,3.042-.466,2.034-.985,4.047-1.511,6.065-.3,1.145-.6,2.287-.908,3.432a.047.047,0,1,1-.088-.032Z",
    transform: "translate(-123.949 -343.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510364",
    "data-name": "Path 510364",
    d: "M176.41,403.964c1.383-.1,2.765-.145,4.148-.173s2.765,0,4.152,0,2.765.1,4.144.221a30.153,30.153,0,0,1,4.111.595l-1.029-.133-1.033-.1c-.687-.056-1.374-.117-2.062-.145-1.378-.08-2.761-.137-4.139-.161s-2.761-.056-4.143-.076Z",
    transform: "translate(-141.794 -340.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510365",
    "data-name": "Path 510365",
    d: "M166.808,354.78A48.712,48.712,0,0,0,165.2,359.6a31.055,31.055,0,0,0-.985,4.983,13.952,13.952,0,0,0-.052,2.524,6.282,6.282,0,0,0,.611,2.411,3.413,3.413,0,0,0,.739.965,6.03,6.03,0,0,0,1.013.711,11.229,11.229,0,0,0,2.323.932,31.06,31.06,0,0,0,4.983.9c1.688.2,3.38.334,5.076.506a36.884,36.884,0,0,1,5.068.8,10.121,10.121,0,0,1,2.431.9,11.494,11.494,0,0,1,2.118,1.5l.382.338h-.514l-13.773-.189-6.872-.068c-2.295,0-4.594,0-6.888.048,2.295-.133,4.59-.169,6.888-.209s4.59-.048,6.888-.052h6.888l6.888.064-.133.334a11.11,11.11,0,0,0-2.042-1.435,9.53,9.53,0,0,0-2.347-.852,39.995,39.995,0,0,0-5.012-.772c-1.688-.181-3.384-.326-5.076-.53a31.793,31.793,0,0,1-5.04-.94,11.076,11.076,0,0,1-2.391-.989,6.6,6.6,0,0,1-1.061-.768,3.739,3.739,0,0,1-.8-1.065,6.555,6.555,0,0,1-.611-2.516,14.413,14.413,0,0,1,.088-2.568,29.67,29.67,0,0,1,1.089-5,44.977,44.977,0,0,1,1.732-4.8Z",
    transform: "translate(-132.494 -311.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510366",
    "data-name": "Path 510366",
    d: "M93.388,419.133c-.173.936,2.5,1.491,3.7,1a25.724,25.724,0,0,0,2.813-1.865c2.962-2.114,7.077-5.225,7.077-5.225l13.982.844,7.8-14.38s-12.861-.743-13.745-1.206l-.165-.088c-4.019-2.046-7.359-3.617-7.74-3.416C106.088,395.365,93.561,418.176,93.388,419.133Z",
    transform: "translate(-92.134 -335.457)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510367",
    "data-name": "Path 510367",
    d: "M117.5,398.67l-7.359,14.553L107,413.033s-4.115,3.115-7.073,5.225a26.374,26.374,0,0,1-2.813,1.865c-1.206.5-3.87-.06-3.7-1s12.708-23.768,13.737-24.335c.378-.213,3.726,1.37,7.74,3.42l.165.08A12.926,12.926,0,0,0,117.5,398.67Z",
    transform: "translate(-92.152 -335.454)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510368",
    "data-name": "Path 510368",
    d: "M92.718,418.966c.173-.961,12.969-24.182,14.018-24.757.4-.225,3.89,1.443,8.038,3.581l.129.068-8.086,15.071-.253-.145s-8.874,6.7-10.092,7.206S92.541,419.927,92.718,418.966Z",
    transform: "translate(-91.733 -335.106)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510369",
    "data-name": "Path 510369",
    d: "M95.211,421.2c2.255-3.858,10.976-19.649,12.913-23.635,0-.032,0-.044-.024,0-2.319,3.778-10.915,19.636-12.953,23.615C95.1,421.255,95.163,421.287,95.211,421.2Z",
    transform: "translate(-93.181 -337.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510370",
    "data-name": "Path 510370",
    d: "M125.174,437.143a6.22,6.22,0,0,0,1.491-5.176c0-.068-.117-.044-.129,0A24.688,24.688,0,0,1,125,437.03a.113.113,0,0,0,.177.113Z",
    transform: "translate(-111.043 -357.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510371",
    "data-name": "Path 510371",
    d: "M121.939,438.993a6.22,6.22,0,0,0,1.491-5.176c0-.068-.117-.044-.129,0a24.763,24.763,0,0,1-1.551,5.048.114.114,0,1,0,.189.129Z",
    transform: "translate(-109.09 -358.782)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510372",
    "data-name": "Path 510372",
    d: "M118.749,440.839a6.238,6.238,0,0,0,1.491-5.18c0-.068-.117-.04-.129,0a24.8,24.8,0,0,1-1.551,5.052.114.114,0,1,0,.189.129Z",
    transform: "translate(-107.182 -359.884)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510373",
    "data-name": "Path 510373",
    d: "M128.263,444.443c1.165-.145,1.411-1.479,1.226-2.411a9.38,9.38,0,0,0-2.222-4.316.044.044,0,0,0-.072,0,.221.221,0,0,0-.326.137,15.078,15.078,0,0,0-.4,4.7C126.592,443.438,127.158,444.584,128.263,444.443Zm-1.27-4.2c.1-.756.225-1.5.293-2.263.43.844.9,1.664,1.242,2.548a10.527,10.527,0,0,1,.434,1.3c.161.687.048,2.994-1.491,1.788-.84-.663-.591-2.476-.478-3.376Z",
    transform: "translate(-111.874 -361.121)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510374",
    "data-name": "Path 510374",
    d: "M130.656,427.575a15.858,15.858,0,0,0-2.89,3.726.213.213,0,0,0,.145.317c0,.032,0,.06.052.056a9.34,9.34,0,0,0,4.566-1.648c.776-.563,1.507-1.7.752-2.608S131.363,427.008,130.656,427.575Zm1.483-.088c1.949.169.462,1.929-.129,2.323a10.564,10.564,0,0,1-1.206.659c-.86.4-1.756.7-2.648,1.021.47-.6.88-1.238,1.326-1.857.514-.735,1.575-2.243,2.636-2.146Z",
    transform: "translate(-112.683 -354.682)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510375",
    "data-name": "Path 510375",
    d: "M170.94,351.138s.4,5.132.37,8.508c0,0,18.953,8.761,19.777,17.768.293,3.187-.133,9.163-6.386,11.888-6.989,3.042-45.611.948-45.611.948l4.823-17.784h17.032s-12.021,1.913-13.327-6.1c-1.206-7.447,3.36-15.24,3.36-15.24Z",
    transform: "translate(-119.473 -309.352)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510376",
    "data-name": "Path 510376",
    d: "M149,423.117c.426-2.046.836-4.107,1.31-6.145s.985-4.075,1.523-6.1c.153-.575.305-1.141.462-1.712.072-.273.149-.547.225-.8a8.079,8.079,0,0,1,.249-.8c0-.028.044,0,.044,0a13.907,13.907,0,0,1-.305,1.571c-.109.494-.213.993-.322,1.487q-.33,1.527-.683,3.042c-.466,2.034-.985,4.047-1.511,6.065l-.9,3.432C149.076,423.2,149,423.185,149,423.117Z",
    transform: "translate(-125.4 -343.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510377",
    "data-name": "Path 510377",
    d: "M178.85,403.964c1.378-.1,2.761-.145,4.144-.173s2.769,0,4.152,0,2.769.1,4.148.221a30.1,30.1,0,0,1,4.1.607l-1.029-.133-1.029-.1c-.687-.056-1.374-.117-2.066-.145-1.378-.08-2.757-.137-4.139-.161s-2.761-.056-4.14-.076Z",
    transform: "translate(-143.254 -340.841)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510378",
    "data-name": "Path 510378",
    d: "M169.23,354.78a49.808,49.808,0,0,0-1.608,4.823,31.5,31.5,0,0,0-.985,4.983,14.324,14.324,0,0,0-.052,2.524,6.285,6.285,0,0,0,.615,2.411,3.4,3.4,0,0,0,.735.965,6.368,6.368,0,0,0,1.013.711,11.319,11.319,0,0,0,2.323.932,31.029,31.029,0,0,0,4.988.9c1.684.2,3.38.334,5.076.506a36.927,36.927,0,0,1,5.064.8,10.085,10.085,0,0,1,2.435.9,11.629,11.629,0,0,1,2.118,1.5l.382.338h-.518l-13.773-.189-6.888-.052c-2.295,0-4.59,0-6.884.048,2.291-.133,4.59-.169,6.884-.209s4.594-.048,6.888-.052h6.892l6.888.064-.137.334a11.11,11.11,0,0,0-2.042-1.435,9.5,9.5,0,0,0-2.343-.852,40.11,40.11,0,0,0-5.012-.772c-1.688-.181-3.384-.326-5.08-.531a31.879,31.879,0,0,1-5.04-.94,11.159,11.159,0,0,1-2.411-.989,6.562,6.562,0,0,1-1.057-.768,3.665,3.665,0,0,1-.8-1.065,6.483,6.483,0,0,1-.611-2.516,14.413,14.413,0,0,1,.088-2.568,29.286,29.286,0,0,1,1.089-5A44.987,44.987,0,0,1,169.23,354.78Z",
    transform: "translate(-133.935 -311.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510379",
    "data-name": "Path 510379",
    d: "M178.635,360.252c.961,0,3.947.169,5.373-1.033,1.153-.977,1.66-4.3,1.861-5.225,0-.048.076-.032.076,0a10.448,10.448,0,0,1-.4,3.05,4.875,4.875,0,0,1-1.206,2.375,4.823,4.823,0,0,1-2.6.952,11.935,11.935,0,0,1-3.1-.044.052.052,0,0,1,0-.076Z",
    transform: "translate(-143.115 -311.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510380",
    "data-name": "Path 510380",
    d: "M219.26,372.32c6.458,2.942,12.808,6.732,17.43,12.222a11.253,11.253,0,0,1,1.555,12.234c-1.608,3.472-4.32,5.257-8,6a39.258,39.258,0,0,1-10.24.735c4.8-.024,12.732-.265,16.052-4.1a11.088,11.088,0,0,0,.615-14.319C232.08,379.474,225.714,375.531,219.26,372.32Z",
    transform: "translate(-167.423 -322.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510381",
    "data-name": "Path 510381",
    d: "M198.465,285.664c-1.073.121-3.436-1.744-4.421-3.384-.064-.113.064-1.33.149-2.813.048-.9.08-1.909.044-2.813,0-.185.651.133.651.133l1.206.241,3.975.8a14.692,14.692,0,0,0-.4,3.549,2.143,2.143,0,0,0,.052.378v.06C199.851,282.514,200.145,285.479,198.465,285.664Z",
    transform: "translate(-152.331 -264.772)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510382",
    "data-name": "Path 510382",
    d: "M200.456,282.354v.06a3.739,3.739,0,0,1-.591.056c-3.886.064-4.565-4.851-4.565-4.851h1.535l3.975.8a14.69,14.69,0,0,0-.4,3.549A2.139,2.139,0,0,0,200.456,282.354Z",
    transform: "translate(-153.093 -265.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510383",
    "data-name": "Path 510383",
    d: "M192.994,252.977c-.8,1.985-.193,7.965,1.149,9.4,1.945,2.074,5.373,2.54,7.2.145,1.772-2.323.856-10.1-.663-11.43A5.1,5.1,0,0,0,192.994,252.977Z",
    transform: "translate(-151.498 -248.896)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510384",
    "data-name": "Path 510384",
    d: "M207.563,267s-.032.024-.028.04c.068.4.08.868-.265,1.053v.02C207.7,268,207.684,267.378,207.563,267Z",
    transform: "translate(-160.252 -259.033)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510385",
    "data-name": "Path 510385",
    d: "M206.3,266.108c-.651.04-.522,1.342.08,1.306S206.842,266.064,206.3,266.108Z",
    transform: "translate(-159.41 -258.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510386",
    "data-name": "Path 510386",
    d: "M213.28,266.33a.037.037,0,0,1,.036.032c.024.4.125.86.5.961v.02C213.368,267.327,213.239,266.716,213.28,266.33Z",
    transform: "translate(-163.842 -258.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510387",
    "data-name": "Path 510387",
    d: "M213.607,265.18c.643-.113.8,1.182.229,1.286S213.069,265.276,213.607,265.18Z",
    transform: "translate(-163.852 -257.94)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510388",
    "data-name": "Path 510388",
    d: "M204.936,263.309a4.455,4.455,0,0,0,.486-.229.86.86,0,0,0,.45-.326.277.277,0,0,0-.076-.326.683.683,0,0,0-.7,0,1.013,1.013,0,0,0-.535.49.293.293,0,0,0,.37.39Z",
    transform: "translate(-158.621 -256.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510389",
    "data-name": "Path 510389",
    d: "M213.426,262.592a4.852,4.852,0,0,1-.53-.084.868.868,0,0,1-.522-.185.273.273,0,0,1,0-.338.671.671,0,0,1,.663-.2,1.021,1.021,0,0,1,.651.322.3.3,0,0,1-.261.482Z",
    transform: "translate(-163.269 -255.903)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510390",
    "data-name": "Path 510390",
    d: "M207.3,276.474c.1.084.213.2.362.2a1.121,1.121,0,0,0,.422-.145h0a.531.531,0,0,1-.49.269.426.426,0,0,1-.35-.322.028.028,0,1,1,.056-.008Z",
    transform: "translate(-160.234 -264.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510391",
    "data-name": "Path 510391",
    d: "M208.117,266.648a1.4,1.4,0,0,0,.977.518,1.734,1.734,0,0,0,.5-.028.346.346,0,0,0,.092-.02l.084-.02a.1.1,0,0,0,.072-.1h0a.121.121,0,0,0,0-.04h0v-.036a4.771,4.771,0,0,0-.1-.78c.121.044.723.249.7.088a20.691,20.691,0,0,0-.944-4.1c0-.044-.08-.024-.072,0,.153,1.29.535,2.544.711,3.838a2.412,2.412,0,0,0-.667-.133c-.044,0,.165.9.161,1.045h0a1.9,1.9,0,0,1-1.463-.3C208.121,266.588,208.093,266.616,208.117,266.648Z",
    transform: "translate(-160.753 -256.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510392",
    "data-name": "Path 510392",
    d: "M209.238,273.746a1.607,1.607,0,0,1-.6.567.72.72,0,0,1-.442.072c-.334-.052-.37-.346-.334-.6a1.627,1.627,0,0,1,.1-.4,2.118,2.118,0,0,0,1.27.366Z",
    transform: "translate(-160.6 -262.849)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510393",
    "data-name": "Path 510393",
    d: "M208.639,274.908a.72.72,0,0,1-.442.072c-.334-.052-.37-.346-.334-.6A.764.764,0,0,1,208.639,274.908Z",
    transform: "translate(-160.6 -263.445)",
    fill: "#ff9bbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510394",
    "data-name": "Path 510394",
    d: "M192,257.749c1.109-.346,1.583-4.107,1.583-4.107s.028,1.587.326,1.543,1.463-2.235,1.559-3.786a12.225,12.225,0,0,0,2.865,1.306c1.427.4,2.99.253,2.986,0A4.622,4.622,0,0,0,194.564,249a4.888,4.888,0,0,0-3.171,3.617C191.08,253.79,191.578,257.877,192,257.749Z",
    transform: "translate(-150.697 -247.993)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510395",
    "data-name": "Path 510395",
    d: "M202.961,267.065a1.9,1.9,0,1,1,1.949-2.283h0a1.909,1.909,0,0,1-1.479,2.247A1.885,1.885,0,0,1,202.961,267.065Zm.161-3.545a1.55,1.55,0,0,0-.4.032,1.648,1.648,0,1,0,.4-.032Z",
    transform: "translate(-156.59 -256.799)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510396",
    "data-name": "Path 510396",
    d: "M214.355,266.247a1.768,1.768,0,0,1-1.419-1.8,2.267,2.267,0,0,1,.305-1.354,1.181,1.181,0,0,1,2.021-.141,2.231,2.231,0,0,1,.494,1.294,1.731,1.731,0,0,1-1.278,2.01Zm-.028-3.545h-.1a1,1,0,0,0-.772.522,2.009,2.009,0,0,0-.269,1.206c.064.9.631,1.608,1.274,1.559s1.105-.8,1.041-1.724a2.009,2.009,0,0,0-.434-1.153,1.049,1.049,0,0,0-.743-.41Z",
    transform: "translate(-163.636 -256.31)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510397",
    "data-name": "Path 510397",
    d: "M210.127,266.744l-.177-.185a1.035,1.035,0,0,1,1.411-.169l-.173.185C210.742,266.161,210.151,266.72,210.127,266.744Z",
    transform: "translate(-161.855 -258.535)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510398",
    "data-name": "Path 510398",
    d: "M189.1,268.245l-.233-.1c.044-.112.474-1.069,1.033-1.206a40.663,40.663,0,0,1,4.091-.04v.253c-.981,0-3.617-.06-4.019.036S189.216,267.98,189.1,268.245Z",
    transform: "translate(-149.247 -258.952)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510399",
    "data-name": "Path 510399",
    d: "M191.968,267.11s-1.206-1.989-2.114-1.567-.06,3.247.932,3.689a1.033,1.033,0,0,0,1.419-.47Z",
    transform: "translate(-149.604 -258.126)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510400",
    "data-name": "Path 510400",
    d: "M191.067,267.63s-.02.02,0,.028a2.612,2.612,0,0,1,1.25,1.716.571.571,0,0,0-.844-.209v.04a.639.639,0,0,1,.687.265,3.109,3.109,0,0,1,.3.587c.028.064.145.04.125-.036h0C192.662,269.1,192.035,267.779,191.067,267.63Z",
    transform: "translate(-150.555 -259.41)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510401",
    "data-name": "Path 510401",
    d: "M196.649,248.223a8.717,8.717,0,0,0-2.347-.92c-.92-.2-3.882-.213-4.638.318s-1.174,3.283-1.226,3.689-.076,2.87.764,3.537,1.27-3.492,2.785-4.754A12.887,12.887,0,0,1,196.649,248.223Z",
    transform: "translate(-148.976 -247.176)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510402",
    "data-name": "Path 510402",
    d: "M196.876,248.757a12.808,12.808,0,0,0-4.662,1.869c-1.515,1.266-1.953,5.418-2.793,4.754a1.965,1.965,0,0,1-.631-1.362,10.148,10.148,0,0,1,2.062-4.268,6.272,6.272,0,0,1,4.5-1.68,9.987,9.987,0,0,1,1.523.687Z",
    transform: "translate(-149.199 -247.711)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510403",
    "data-name": "Path 510403",
    d: "M189.082,258.364a16.336,16.336,0,0,1,2.874-5.582c1.326-1.6,4.887-2.307,5.381-2.239,1.178.165,1.547.559,1.744.466s-.948-1.077-1.262-1.306a4.494,4.494,0,0,0-1.684-.8c-.514-.036-3.705.02-4.971,1.274s-3.215,4.9-2.99,5.892c.052.237.35.4.422.752.092.442.141.953.245,1.266S189.066,258.456,189.082,258.364Z",
    transform: "translate(-148.819 -248.203)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510404",
    "data-name": "Path 510404",
    d: "M196.429,254.649a5.587,5.587,0,0,1-.719-.627,3.851,3.851,0,0,1-.595-.756c0-.02-.044,0-.036,0a3.139,3.139,0,0,0,.53.836,2.637,2.637,0,0,0,.8.587C196.433,254.722,196.457,254.673,196.429,254.649Z",
    transform: "translate(-152.96 -250.814)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510405",
    "data-name": "Path 510405",
    d: "M189.6,266.763a2.573,2.573,0,0,0-.1-.241,1.33,1.33,0,0,1-.08-.281,2.336,2.336,0,0,0-.08-.563,1.9,1.9,0,0,0-.229-.4.752.752,0,0,1-.181-.47.018.018,0,0,0-.036,0,1.893,1.893,0,0,0,.3.892,4.176,4.176,0,0,1,.1.587.84.84,0,0,0,.253.49C189.569,266.811,189.609,266.791,189.6,266.763Z",
    transform: "translate(-149.259 -257.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510406",
    "data-name": "Path 510406",
    d: "M190.543,264.095c-.092-.133-.2-.257-.281-.4a3.534,3.534,0,0,1-.2-.434c-.06-.149-.1-.3-.161-.446s-.153-.342-.209-.518c0-.024-.04,0-.032,0,.056.185.084.4.137.567a4.69,4.69,0,0,0,.173.47,2.668,2.668,0,0,0,.229.446,1.242,1.242,0,0,0,.334.346S190.551,264.107,190.543,264.095Z",
    transform: "translate(-149.718 -256.212)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510407",
    "data-name": "Path 510407",
    d: "M191.624,261.9a3.13,3.13,0,0,1-.547-.731c-.141-.265-.265-.539-.4-.8h-.036a3.8,3.8,0,0,0,.313.876,2.11,2.11,0,0,0,.253.374,2.319,2.319,0,0,0,.374.309S191.64,261.911,191.624,261.9Z",
    transform: "translate(-150.305 -255.061)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510408",
    "data-name": "Path 510408",
    d: "M192.994,259.359a1.037,1.037,0,0,1-.269-.321c-.084-.133-.169-.269-.245-.4s-.157-.261-.229-.4a1.049,1.049,0,0,1-.165-.426c0-.02-.036-.02-.036,0a1.133,1.133,0,0,0,.088.446,2.77,2.77,0,0,0,.217.454,3.189,3.189,0,0,0,.277.4.711.711,0,0,0,.338.277A.019.019,0,1,0,192.994,259.359Z",
    transform: "translate(-151.149 -253.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510409",
    "data-name": "Path 510409",
    d: "M194.286,256.847c-.092-.113-.185-.221-.273-.338s-.165-.237-.241-.358-.165-.253-.241-.4H193.5a3.19,3.19,0,0,0,.169.4,3.344,3.344,0,0,0,.241.378,3.257,3.257,0,0,0,.277.346,1.129,1.129,0,0,0,.338.281s.044,0,.036-.032A1.955,1.955,0,0,0,194.286,256.847Z",
    transform: "translate(-152.014 -252.304)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510410",
    "data-name": "Path 510410",
    d: "M198.454,253.135a5.105,5.105,0,0,0-.305-.422c-.113-.137-.237-.269-.362-.4a5.06,5.06,0,0,0-.8-.651s-.044,0-.028.028c.49.49,1,.965,1.479,1.463C198.442,253.175,198.47,253.155,198.454,253.135Z",
    transform: "translate(-154.08 -249.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510411",
    "data-name": "Path 510411",
    d: "M200.652,251.609a2.286,2.286,0,0,0-.346-.4,5.112,5.112,0,0,0-.908-.607c-.02,0-.04,0-.02.028.269.217.547.426.8.659a3.89,3.89,0,0,1,.37.358c.117.129.2.277.309.4h.024A1.354,1.354,0,0,0,200.652,251.609Z",
    transform: "translate(-155.527 -249.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510412",
    "data-name": "Path 510412",
    d: "M203.347,250.814a2.46,2.46,0,0,0-.317-.4,2.813,2.813,0,0,0-.772-.543c-.02,0-.036.02,0,.032a5.487,5.487,0,0,1,.715.619c.113.113.217.229.322.35a3.917,3.917,0,0,0,.309.366h0A2.54,2.54,0,0,0,203.347,250.814Z",
    transform: "translate(-157.241 -248.787)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510413",
    "data-name": "Path 510413",
    d: "M205.644,250.181c-.109-.1-.221-.2-.334-.3a1.532,1.532,0,0,0-.37-.249c-.02,0-.032,0,0,.032l.627.611a3.59,3.59,0,0,1,.466.655h.024a1.439,1.439,0,0,0-.414-.748Z",
    transform: "translate(-158.847 -248.644)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510414",
    "data-name": "Path 510414",
    d: "M207.75,249.932a2.23,2.23,0,0,0-.7-.522c-.02,0-.036.02-.02.032a2.813,2.813,0,0,1,.631.563,4.018,4.018,0,0,1,.478.7h.024A1.881,1.881,0,0,0,207.75,249.932Z",
    transform: "translate(-160.105 -248.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510415",
    "data-name": "Path 510415",
    d: "M210.074,250.633a1.15,1.15,0,0,0-.08-.177,1.9,1.9,0,0,0-.221-.321,3.923,3.923,0,0,0-.591-.535s-.04,0-.02.028a3.215,3.215,0,0,1,.547.547,2.434,2.434,0,0,1,.213.317,1.278,1.278,0,0,1,.084.165,1.244,1.244,0,0,0,.08.165h.032A.479.479,0,0,0,210.074,250.633Z",
    transform: "translate(-161.38 -248.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510416",
    "data-name": "Path 510416",
    d: "M212.115,251.359a3.083,3.083,0,0,0-.181-.265,3.028,3.028,0,0,0-.213-.241c-.076-.076-.161-.153-.233-.233l-.028.024a1.852,1.852,0,0,1,.217.253c.064.084.125.169.189.249l.189.253a2.979,2.979,0,0,0,.185.257h.028A1.462,1.462,0,0,0,212.115,251.359Z",
    transform: "translate(-162.758 -249.236)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510417",
    "data-name": "Path 510417",
    d: "M157.68,318.173c.052.068,25.48,2.709,25.721,2.472.362-.334-1.644-26.215-5.225-32.123-.892-1.479-4.421-2.733-6.052-1.447-4.7,3.722-5.9,7.081-7.278,9.8a81.94,81.94,0,0,0-3.557,9.039C159.28,311.783,157.5,317.912,157.68,318.173Z",
    transform: "translate(-130.584 -270.72)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510418",
    "data-name": "Path 510418",
    d: "M252.924,282.186s-2.411-.5-1.929-2.114,2.777-.731,2.777-.731Z",
    transform: "translate(-186.366 -266.27)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510419",
    "data-name": "Path 510419",
    d: "M273.1,284.493h0l1.728,1.668.575.551-.78.157-2.359.47h0L255.7,282.475l.832-2.845Z",
    transform: "translate(-189.218 -266.587)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510420",
    "data-name": "Path 510420",
    d: "M302.959,295.88l.575.551-.784.157Z",
    transform: "translate(-217.359 -276.306)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204090",
    "data-name": "Rectangle 204090",
    width: 3.46,
    height: 0.687,
    transform: "translate(66.309 16.11) rotate(-73.64)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204091",
    "data-name": "Rectangle 204091",
    width: 3.46,
    height: 0.687,
    transform: "translate(67.029 16.304) rotate(-73.65)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510421",
    "data-name": "Path 510421",
    d: "M258.71,286.653l.318-1.073,5.819,2.351-.141.386Z",
    transform: "translate(-191.019 -270.146)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510422",
    "data-name": "Path 510422",
    d: "M196.222,292.187c1.889,3.026,10.554,13.942,15.272,13.857a49.028,49.028,0,0,0,16.052-3.484c1.8-.776-4.357-9.75-5.964-8.974a48.087,48.087,0,0,1-8.6,2.5c-1.009.2-8.842-4.726-13.15-7.2C195.932,286.661,195.108,290.4,196.222,292.187Z",
    transform: "translate(-153.371 -271.713)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510423",
    "data-name": "Path 510423",
    d: "M270.87,285.054c.559,1.206-2.5,2.319-2.5,2.319a2.412,2.412,0,0,1,1.451.8c.627.78-.318,2.106-.318,2.106a2.982,2.982,0,0,1,1.4,1.073c.526.8-.233,2.279-.233,2.279a2.625,2.625,0,0,1,.635,1.716c-.072,1.684-2.311,2.954-3.726,3.778s-6.2,1.829-7.089,2.11L255.14,292.2s5.3-5.49,7.1-6.221C263.757,285.347,270.018,283.233,270.87,285.054Z",
    transform: "translate(-188.883 -269.398)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510424",
    "data-name": "Path 510424",
    d: "M280.382,291.838a21.9,21.9,0,0,0-5.108,1.64.032.032,0,0,0,.024.056c1.608-.7,3.464-.981,5.1-1.608a.045.045,0,0,0-.02-.088Z",
    transform: "translate(-200.919 -273.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510425",
    "data-name": "Path 510425",
    d: "M283.829,298.839a4.655,4.655,0,0,0-1.133.446c-.4.189-.78.382-1.161.579-.768.4-1.527.8-2.275,1.254-.032.02,0,.076.024.056.768-.4,1.539-.78,2.323-1.141.4-.185.784-.362,1.178-.539a5.626,5.626,0,0,0,1.089-.547.06.06,0,0,0-.044-.109Z",
    transform: "translate(-203.302 -278.076)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510426",
    "data-name": "Path 510426",
    d: "M287.527,307.47a3.272,3.272,0,0,0-1,.458c-.346.189-.691.378-1.041.563-.7.37-1.395.739-2.1,1.085a.032.032,0,0,0,.024.056c.719-.35,1.447-.687,2.166-1.041l1.057-.526a2.982,2.982,0,0,0,.916-.563S287.543,307.466,287.527,307.47Z",
    transform: "translate(-205.77 -283.238)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510427",
    "data-name": "Path 510427",
    d: "M218.859,293.5,224,303.647s-9.754,3.34-13.958,2.331-10.481-8.255-13.576-12.555-2.243-8.343,4.859-4.019,10.449,5.936,10.927,5.972S218.859,293.5,218.859,293.5Z",
    transform: "translate(-152.775 -271.325)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510428",
    "data-name": "Path 510428",
    d: "M217,315.72c-.056-.036-4.421-.092-5.606-.888a78.712,78.712,0,0,1-11.333-10.972l-.028.024c.679.981,1.423,1.921,2.194,2.837-.052-.04-.108-.076-.165-.113a16.688,16.688,0,0,1-1.395-.977c-.032-.024-.068.028-.036.056.446.338.86.723,1.3,1.077.209.173.422.342.647.494l.269.181c.245.277.49.555.74.828.635.7,6.028,6.028,7.965,6.989,1.226.6,5.112.607,5.486.514C217.074,315.76,217.038,315.744,217,315.72Z",
    transform: "translate(-155.922 -281.079)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510429",
    "data-name": "Path 510429",
    d: "M254.818,314.435a25.478,25.478,0,0,0-1.105-2.379q-.559-1.158-1.145-2.307c-.78-1.547-1.527-3.123-2.411-4.618a.033.033,0,1,0-.06.028c.631,1.608,1.435,3.215,2.21,4.762q.583,1.178,1.206,2.339a22.952,22.952,0,0,0,1.25,2.21.033.033,0,0,0,.056-.036Z",
    transform: "translate(-185.864 -281.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510430",
    "data-name": "Path 510430",
    d: "M183.287,286.785c-1.929-1.258-7.439-2.2-9.8-.888-2.982,1.656-6.511,12.406-5.413,13.154,1.957,1.33,9.605-4.445,11.378-6.929S183.287,286.785,183.287,286.785Z",
    transform: "translate(-136.687 -269.956)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510431",
    "data-name": "Path 510431",
    d: "M184.166,295.172c-.4.35-.8.691-1.206,1.045.543-.719,1.089-1.435,1.608-2.17.02-.024,0-.056-.04-.036a30.017,30.017,0,0,0-1.969,2.311c-.655.8-1.314,1.608-2.009,2.355a20.306,20.306,0,0,1-2.214,2.146,21.305,21.305,0,0,1-2.681,1.829q-.8.47-1.608.9a12.858,12.858,0,0,1-1.8.8c-.117.036-.044.08,0,.068a9.019,9.019,0,0,0,1.531-.579c.514-.241,1.029-.478,1.535-.727a19.133,19.133,0,0,0,2.813-1.608,19.686,19.686,0,0,0,4.3-4.565l.072-.1c.237-.213.466-.434.687-.659.322-.33.655-.639,1-.94C184.227,295.208,184.166,295.144,184.166,295.172Z",
    transform: "translate(-139.266 -275.184)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-12",
    transform: "translate(114.326 61.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510432",
    "data-name": "Path 510432",
    d: "M206.71,219.05v9.979h1.4v2.419l2.419-2.419h13.283V219.05Z",
    transform: "translate(-206.614 -170.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510433",
    "data-name": "Path 510433",
    d: "M206.566,218.793c.036,2.492.092,7.491.121,9.979l-.121-.121h1.527V231.2l-.253-.1,2.411-2.435c.06-.06.044-.052.121-.052l13.262-.024-.2.2.028-9.979.169.173c-4.26-.024-12.84-.117-17.1-.173Zm0,0c4.348-.056,12.921-.145,17.281-.173v.173l.024,9.979v.2h-.2l-13.262-.024.125-.052-2.7,2.661c0-.121.028-2.576.024-2.781l.129.133H206.47c.028-2.548.084-7.552.125-10.1Z",
    transform: "translate(-206.47 -170.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510434",
    "data-name": "Path 510434",
    d: "M236,230.274a.8.8,0,1,0,.8-.8A.8.8,0,0,0,236,230.274Z",
    transform: "translate(-224.132 -177.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510435",
    "data-name": "Path 510435",
    d: "M226,230.274a.8.8,0,1,0,.8-.8A.8.8,0,0,0,226,230.274Z",
    transform: "translate(-218.151 -177.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510436",
    "data-name": "Path 510436",
    d: "M215.91,230.274a.8.8,0,1,0,.8-.8A.8.8,0,0,0,215.91,230.274Z",
    transform: "translate(-212.116 -177.003)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510437",
    "data-name": "Path 510437",
    d: "M592.16,99.35v9.975h1.4v2.419l2.419-2.419h13.283V99.35Z",
    transform: "translate(-437.154 -99.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510438",
    "data-name": "Path 510438",
    d: "M591.986,99.093c.04,2.488.093,7.487.121,9.975l-.121-.121h1.531v2.544l-.253-.1,2.411-2.435c.056-.06.044-.048.12-.048l13.283-.028-.2.2.024-9.975.173.169c-4.264-.024-12.861-.117-17.1-.169Zm0,0c4.353-.056,12.925-.149,17.281-.173v.173l.024,9.975v.2h-.2l-13.283-.024.121-.052c-.08.084-2.721,2.689-2.693,2.661,0-.121.028-2.576.02-2.781l.133.133H591.87c.028-2.548.084-7.552.12-10.1Z",
    transform: "translate(-436.981 -98.92)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510439",
    "data-name": "Path 510439",
    d: "M621.49,110.564a.8.8,0,1,0,.8-.8A.8.8,0,0,0,621.49,110.564Z",
    transform: "translate(-454.697 -105.403)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510440",
    "data-name": "Path 510440",
    d: "M611.42,110.564a.8.8,0,1,0,.8-.8A.8.8,0,0,0,611.42,110.564Z",
    transform: "translate(-448.674 -105.403)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510441",
    "data-name": "Path 510441",
    d: "M601.36,110.564a.8.8,0,1,0,.8-.8A.8.8,0,0,0,601.36,110.564Z",
    transform: "translate(-442.657 -105.403)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySevas);
export default __webpack_public_path__ + "static/media/EmptySevas.0d56e811f69ea2cdc0f28923aa56eda0.svg";
export { ForwardRef as ReactComponent };